/**
 * English strings for the MES module. Keys are the original Croatian copy so
 * existing screens can wrap text with t("...") without inventing a second
 * key space. Missing keys fall back to Croatian.
 */
const en: Record<string, string> = {
  // Navigation
  Planiranje: "Planning",
  Timeline: "Timeline",
  "Starter plan": "Starter plan",
  Osoblje: "Staff",
  Izvrsavanje: "Execution",
  "Radni nalozi": "Work orders",
  "Nalozi proizvodnje": "Production orders",
  "Radni nalozi (tablet)": "Work orders (tablet)",
  "Procesni podaci": "Process data",
  Razvoj: "Development",
  "Nova proba": "New trial",
  "Spremljene probe": "Saved trials",
  Dashboard: "Dashboard",
  Laboratorij: "Laboratory",
  "Labos nalozi": "Lab orders",
  "Labos mjerenja": "Lab measurements",
  Skladiste: "Warehouse",
  Skladište: "Warehouse",
  Primke: "Goods receipts",
  "Međuskladišnice": "Inter-warehouse transfers",
  "Stanje po skladištu": "Stock by warehouse",
  Inventura: "Stocktake",
  "Gotovi proizvodi": "Finished goods",
  "LOT-ovi": "Lots",
  Otpremnice: "Dispatch notes",
  Sljedivost: "Traceability",
  Kvaliteta: "Quality",
  "Red čekanja": "Queue",
  "Povijest testiranih": "Tested history",
  Pracenje: "Monitoring",
  KPI: "KPI",
  Batchevi: "Batches",
  Financije: "Finance",
  "Cijene sirovina": "Ingredient prices",
  "Troskovi proizvoda": "Product costs",
  Baza: "Master data",
  Proizvodi: "Products",
  Recepti: "Recipes",
  Sirovine: "Ingredients",
  Poluproizvodi: "Semi-finished",
  Strojevi: "Machines",
  Nabava: "Procurement",
  "Zahtjev za narudžbu": "Purchase request",
  Pregled: "Overview",
  "Registar dokumenata": "Document register",
  Izvjestaji: "Reports",
  "Dnevni izvještaj": "Daily report",

  // Page headers
  "MES - Planiranje": "MES - Planning",
  "MES - Priprema startera": "MES - Starter prep",
  "MES - Osoblje": "MES - Staff",
  "MES - Radni nalozi": "MES - Work orders",
  "MES - Nalozi proizvodnje": "MES - Production orders",
  "MES - Radni nalozi (tablet)": "MES - Work orders (tablet)",
  "MES - Procesni parametri": "MES - Process parameters",
  "MES - Nova proba": "MES - New trial",
  "MES - Detalj probe": "MES - Trial detail",
  "MES - Spremljene probe": "MES - Saved trials",
  "MES - Pokusi": "MES - Trials",
  "MES - Dashboard proba": "MES - Trial dashboard",
  "MES - Skladiste": "MES - Warehouse",
  "MES - Skladište": "MES - Warehouse",
  "MES - Recepti": "MES - Recipes",
  "MES - Baza proizvoda": "MES - Product master",
  "MES - Poluproizvodi": "MES - Semi-finished",
  "MES - Sastojci": "MES - Ingredients",
  "MES - Strojevi": "MES - Machines",
  "MES - Troskovi proizvoda": "MES - Product costs",
  "MES - Cijene sastojaka": "MES - Ingredient prices",
  "MES - Dnevni izvještaj": "MES - Daily report",
  "MES - Pracenje proizvodnje": "MES - Production monitoring",
  "MES - Analize brasna": "MES - Flour analyses",
  "MES - Zahtjev za narudžbu": "MES - Purchase request",
  "MES - Pregled": "MES - Overview",
  "MES - KPI Dashboard": "MES - KPI Dashboard",
  "MES - Batchevi": "MES - Batches",
  "MES - Putovnica batcha": "MES - Batch passport",
  "MES - Kvaliteta brašna": "MES - Flour quality",
  "MES - Laboratorij": "MES - Laboratory",

  // Common actions
  Spremi: "Save",
  Odustani: "Cancel",
  Dodaj: "Add",
  "Dodaj red": "Add row",
  Obriši: "Delete",
  Uredi: "Edit",
  Potvrdi: "Confirm",
  "Potvrđeno": "Confirmed",
  Otkaži: "Cancel",
  Pretraži: "Search",
  Učitavanje: "Loading",
  "Učitavanje…": "Loading…",
  "Učitavanje detalja…": "Loading details…",
  "Nema podataka": "No data",
  "Nema rezultata": "No results",
  Greška: "Error",
  Uspješno: "Success",
  Naziv: "Name",
  Datum: "Date",
  Količina: "Quantity",
  Sirovina: "Ingredient",
  Proizvod: "Product",
  Primka: "Goods receipt",
  Nalog: "Order",
  Status: "Status",
  Akcije: "Actions",
  Napomena: "Note",
  Napomene: "Notes",
  Broj: "Number",
  Šifra: "Code",
  Verzija: "Version",
  Jedinica: "Unit",
  Parametar: "Parameter",
  Vrijednost: "Value",
  Dobavljač: "Supplier",
  Kupac: "Customer",
  Lot: "Lot",
  "LOT broj": "LOT number",
  "Rok trajanja": "Expiry date",
  Aktivno: "Active",
  Neaktivno: "Inactive",
  Da: "Yes",
  Ne: "No",
  Sve: "All",
  Filtriraj: "Filter",
  Ispis: "Print",
  "Ispis / spremi PDF": "Print / save PDF",
  Zatvori: "Close",
  Nastavi: "Continue",
  Natrag: "Back",
  Sljedeći: "Next",
  "← Prethodna": "← Previous",
  "Sljedeća →": "Next →",
  "Stranica {page} / {total}": "Page {page} / {total}",
  Danas: "Today",
  Sutra: "Tomorrow",
  Draft: "Draft",
  "Bez uređaja": "No machine",
  "Uređaj #{id}": "Device #{id}",

  // Date selector
  Ned: "Sun",
  Pon: "Mon",
  Uto: "Tue",
  Sri: "Wed",
  Cet: "Thu",
  Pet: "Fri",
  Sub: "Sat",
  Sij: "Jan",
  Velj: "Feb",
  Ozu: "Mar",
  Tra: "Apr",
  Svi: "May",
  Lip: "Jun",
  Srp: "Jul",
  Kol: "Aug",
  Ruj: "Sep",
  Lis: "Oct",
  Stu: "Nov",
  Pro: "Dec",

  // Phases
  Miješanje: "Mixing",
  Dijeljenje: "Dividing",
  Fermentacija: "Fermentation",
  Oblikovanje: "Moulding",
  Obrada: "Processing",
  "Završno dizanje": "Final proof",
  Pečenje: "Baking",
  Hlađenje: "Cooling",
  Pakiranje: "Packaging",
  Mix: "Mix",
  Dij: "Div",
  Ferm: "Ferm",
  Obl: "Mld",
  Obr: "Prc",
  Zav: "Prf",
  Peč: "Bak",
  "Hlađ": "Cool",
  Pak: "Pack",

  // Process fields
  "Početak miješanja": "Mixing start",
  "Kraj miješanja": "Mixing end",
  "Masa zamjesa (kg)": "Dough mass (kg)",
  "Kapacitet miksera (kg)": "Mixer capacity (kg)",
  "Napunjenost (%)": "Fill (%)",
  "masa / kapacitet": "mass / capacity",
  "Temperatura tijesta (°C)": "Dough temperature (°C)",
  "pH startera": "Starter pH",
  "pH zamjesa": "Dough pH",
  "pH (Rheon)": "pH (Rheon)",
  "Δ pH": "Δ pH",
  "pH (Rheon) − pH zamjesa": "pH (Rheon) − dough pH",
  "Energija — vrh (Wh)": "Energy — peak (Wh)",
  "Energija — kraj (Wh)": "Energy — end (Wh)",
  "Početak fermentacije": "Fermentation start",
  "Kraj fermentacije": "Fermentation end",
  "Vis. mjerica (Mikser)": "Height cup (Mixer)",
  "Vis. mjerica (Rheon)": "Height cup (Rheon)",
  "Δ visina (%)": "Δ height (%)",
  "prirast od prve mjerice": "gain from first cup",
  "Tip fermentacije": "Fermentation type",
  "Početak završnog dizanja": "Final proof start",
  "Kraj završnog dizanja": "Final proof end",
  "Visina 1": "Height 1",
  "Visina 2": "Height 2",
  "Početak pečenja": "Baking start",
  "Kraj pečenja": "Baking end",
  "Temperatura pečenja (°C)": "Baking temperature (°C)",
  "pH prije pečenja": "pH before baking",
  "Početak hlađenja": "Cooling start",
  "Početak pakiranja": "Packaging start",
  "Kraj pakiranja": "Packaging end",
  "Proizvedeno (kom)": "Produced (pcs)",
  "Zapakirano (kom)": "Packed (pcs)",
  "Škart po obliku (kom)": "Scrap by shape (pcs)",
  "Škart po boji (kom)": "Scrap by colour (pcs)",
  "Škart ukupno (kom)": "Total scrap (pcs)",
  "oblik + boja": "shape + colour",
  "Škart (%)": "Scrap (%)",
  "od proizvedenih komada": "of produced pieces",
  "Spec. volumen (L/kg)": "Specific volume (L/kg)",

  // Batch / planning statuses
  planned: "planned",
  ready: "ready",
  in_progress: "in progress",
  completed: "completed",
  on_hold: "on hold",
  skipped: "skipped",
  canceled: "canceled",
  Planirano: "Planned",
  Spreman: "Ready",
  "U tijeku": "In progress",
  Završeno: "Completed",
  Pauzirano: "On hold",
  Preskočeno: "Skipped",
  Otkazano: "Canceled",

  // Planning wizard
  "Definiranje proizvoda": "Define products",
  Polugotovi: "Semi-finished",
  "Raspored po danima": "Schedule by day",
  Raspored: "Schedule",
  "Faze po proizvodu": "Phases by product",
  Gantt: "Gantt",
  "Pregled i potvrda": "Review and confirm",

  // Common errors / toasts
  "Greška: {message}": "Error: {message}",
  "Greška kod učitavanja lotova: {message}": "Error loading lots: {message}",
  "Greška kod učitavanja proizvedenih lotova: {message}":
    "Error loading produced lots: {message}",
  "Greška kod učitavanja detalja: {message}": "Error loading details: {message}",

  // Warehouse / traceability
  "Razina 1 — ulazne sirovine": "Level 1 — inbound ingredients",
  "{count} lotova sirovina": "{count} ingredient lots",
  "{count} lotova sirovina (dio bez primke u sustavu)":
    "{count} ingredient lots (some without a receipt in the system)",
  "Nema evidentiranog utroška sirovina za ovaj zamjes.":
    "No recorded ingredient consumption for this mix.",
  Utrošeno: "Consumed",
  "Datum prijema": "Receipt date",
  Zaprimljeno: "Received",
  "Definirana težina": "Defined weight",
  Težine: "Weights",
  "Datum proizvodnje": "Production date",
  "Datum izdavanja": "Issue date",
  "Datum kontrole": "Check date",
  "Proizvod / šifra": "Product / code",
  Dokument: "Document",
  Odredište: "Destination",
  Namjena: "Purpose",
  "Otpis / škart": "Write-off / scrap",
  "Skladište gotovih proizvoda": "Finished-goods warehouse",
  Ostalo: "Other",
  "Pretraži i odaberi ulazni lot da vidiš dijagram sljedivosti":
    "Search and select an inbound lot to see the traceability diagram",
  "Pretraži i odaberi proizvedeni lot da vidiš dijagram sljedivosti":
    "Search and select a produced lot to see the traceability diagram",
  "Nema proizvedenih lotova": "No produced lots",
  "Nema primki na utrošenim lotovima": "No receipts on consumed lots",
  "Nema premještaja ZGSM → ZGPM": "No ZGSM → ZGPM transfers",
  "Nema evidencije ulaznih lotova": "No inbound lot records",
  Veleprodaja: "Wholesale",
  Proizvodnja: "Production",
  "Nema povezanih primki": "No linked receipts",
  "Datum primke": "Receipt date",
  "Datum naloga": "Order date",
  "Nalog je uvezen iz Ritma, koji ne vodi vremena izrade ni strojeve — ta polja":
    "The order was imported from Ritam, which does not keep production times or machines — those fields",
  "Nema evidentiranog sastava zamjesa": "No recorded mix composition",
  "Primka nema stavki": "Receipt has no lines",
  "Nema sirovina za QA": "No ingredients for QA",
  "Nema otpremnica na ovo skladište": "No dispatch notes to this warehouse",
  "Pretraži ulazni lot po dobavljačevom lotu, sirovini ili dobavljaču…":
    "Search inbound lot by supplier lot, ingredient or supplier…",
  "Pretraži proizvedeni lot po šifri, zamjesu ili proizvodu…":
    "Search produced lot by code, mix or product…",
  "Šifra artikla": "Article code",
  "Naziv artikla": "Article name",
  Br: "No.",
  "Br.": "No.",
  Mjera: "UoM",
  Rok: "Expiry",

  // Ingredients / recipes
  "Recepturni parametri": "Recipe parameters",
  "EUR/kg": "EUR/kg",
  "trošak {amount}": "cost {amount}",

  // Finished goods
  "{count} kom ukupno na stanju": "{count} pcs in stock",
  kom: "pcs",

  // KPI / monitoring
  "Nema potvrdjenog plana za {date}.": "No confirmed plan for {date}.",
  "{count} zamjesa - {date}": "{count} mixes - {date}",
  "{count} zapisa u periodu {from} - {to}": "{count} records in period {from} - {to}",

  // Work orders / trials
  "Radni nalozi proba - {date}": "Trial work orders - {date}",

  // Language switcher
  Jezik: "Language",
  Hrvatski: "Croatian",
  Engleski: "English",

  // Warehouse / Overview / Procurement / Finance (auto-added)
  "Narudžbe": "Orders",
  "Dobavljači": "Suppliers",
  "Broj otpremnice": "Dispatch note number",
  "Stavki": "Lines",
  "Karantena": "Quarantine",
  "Rok isporuke": "Delivery date",
  "Prioritet": "Priority",
  "Zamjesa": "Mixes",
  "Sastojaka": "Ingredients",
  "Kategorija": "Category",
  "Masa zamjesa": "Mix mass",
  "Tip": "Type",
  "Kontakt": "Contact",
  "Email": "Email",
  "Telefon": "Phone",
  "Adresa": "Address",
  "Nacrt": "Draft",
  "Zamijenjen": "Superseded",
  "Aktivan": "Active",
  "Aktivna": "Active",
  "Neaktivna": "Inactive",
  "Neaktivan": "Inactive",
  "{label}: {message}": "{label}: {message}",
  "Pregled svih primki, narudžbi, radnih naloga, otpremnica, recepata i povezanih entiteta na jednom mjestu.": "Overview of all receipts, orders, work orders, dispatch notes, recipes and related entities in one place.",
  "učitavanje…": "loading…",
  "{count} zapisa": "{count} records",
  "Pretraži {name}…": "Search {name}…",
  "Nema rezultata pretrage": "No search results",
  "Nema zapisa": "No records",
  "Niski": "Low",
  "Normalni": "Normal",
  "Visoki": "High",
  "Greška pri učitavanju zahtjeva: {message}": "Error loading requests: {message}",
  "Greška pri učitavanju šifrarnika: {message}": "Error loading lookup data: {message}",
  "Greška pri učitavanju detalja: {message}": "Error loading details: {message}",
  "Datum isporuke je obavezan.": "Delivery date is required.",
  "Dodajte barem jednu stavku (sirovina ili novi proizvod).": "Add at least one line (ingredient or new product).",
  "Zahtjev za narudžbu kreiran.": "Purchase request created.",
  "Greška pri spremanju: {message}": "Error saving: {message}",
  "{name} (novi)": "{name} (new)",
  "Nepoznato": "Unknown",
  "Zahtjevi": "Requests",
  "+ Novi zahtjev": "+ New request",
  "Učitavanje...": "Loading...",
  "Nema zahtjeva za narudžbu.": "No purchase requests.",
  "{title} · {count} stavki": "{title} · {count} lines",
  "Bez naziva": "Untitled",
  "Isporuka: {date}": "Delivery: {date}",
  "Datum zahtjeva:": "Request date:",
  "Datum isporuke:": "Delivery date:",
  "Prioritet:": "Priority:",
  "Status:": "Status:",
  "Skladište:": "Warehouse:",
  "Napomena:": "Note:",
  "Stavke": "Lines",
  "Stavka": "Line",
  "Zahtjev nema stavki.": "The request has no lines.",
  "Odaberite zahtjev za prikaz detalja.": "Select a request to view details.",
  "NOVI ZAHTJEV ZA NARUDŽBU": "NEW PURCHASE REQUEST",
  "Nabava - kreiranje zahtjeva sa stavkama": "Procurement — create a request with lines",
  "Naziv zahtjeva": "Request title",
  "npr. Tjedna nabava sirovina": "e.g. weekly ingredient purchase",
  "Datum isporuke *": "Delivery date *",
  "- (ili upiši novi proizvod) -": "- (or type a new product) -",
  "Novi proizvod (slobodan unos)": "New product (free text)",
  "ako nije u šifrarniku": "if not in the catalog",
  "Napomena stavke": "Line note",
  "Ukloni stavku": "Remove line",
  "Spremanje...": "Saving...",
  "Spremi zahtjev": "Save request",
  "Sastojci": "Ingredients",
  "Nema cijene": "No price",
  "Povijest cijena: {name}": "Price history: {name}",
  "+ Nova cijena": "+ New price",
  "Nema povijesti cijena za ovaj sastojak.": "No price history for this ingredient.",
  "danas": "today",
  "AKTIVNO": "ACTIVE",
  "Graf kretanja cijena (TODO)": "Price trend chart (TODO)",
  "Odaberite sastojak za prikaz povijesti cijena.": "Select an ingredient to view price history.",
  "NOVA CIJENA": "NEW PRICE",
  "Unos cijene za {name}": "Enter price for {name}",
  "Sastojak": "Ingredient",
  "Cijena (EUR/kg) *": "Price (EUR/kg) *",
  "npr. 1.50": "e.g. 1.50",
  "Vrijedi od *": "Valid from *",
  "* Stara cijena ce automatski isteci danom prije novog datuma.": "* The previous price will expire the day before the new date.",
  "Spremi cijenu": "Save price",
  "Greska pri ucitavanju: {message}": "Error loading: {message}",
  "Pretrazi proizvod": "Search product",
  "npr. multigrain, ciabatta...": "e.g. multigrain, ciabatta...",
  "Samo bez prodajne cijene": "Only without a selling price",
  "proizvoda": "products",
  "Ucitavanje...": "Loading...",
  "Pregled troskova": "Cost overview",
  "Masa (g)": "Mass (g)",
  "EUR/kg tijesta": "EUR/kg dough",
  "Sirovine/kom": "Ingredients/pc",
  "Pakiranje/kom": "Packaging/pc",
  "Ukupni trosak/kom": "Total cost/pc",
  "Prod. cijena": "Sell. price",
  "Profit/kom": "Profit/pc",
  "Marza %": "Margin %",
  "Detalj recepture: {name}": "Recipe detail: {name}",
  "Ukupni materijal/kom": "Total material/pc",
  "Prodajna cijena": "Selling price",
  "{pct} marza": "{pct} margin",
  "Receptura je u apsolutnim kolicinama (g / kom / list). Obracun troska za slasticarske recepture jos nije podrzan.": "The recipe uses absolute quantities (g / pcs / sheet). Cost calculation for pastry recipes is not supported yet.",
  "PEK %": "Bakers %",
  "Trosak": "Cost",
  "Ukupno PEK%:": "Total bakers %:",
  "Trosak/kg tijesta:": "Cost/kg dough:",
  "Masa komada:": "Piece mass:",
  "Nema aktivne recepture za ovaj proizvod.": "No active recipe for this product.",
  "{count} proizvoda": "{count} products",
  "Stanje po skladištima": "Stock by warehouse",
  "Pregled artikala — što je na stanju, koliko i u kojem skladištu": "Article overview — what is in stock, how much and in which warehouse",
  "Sva skladišta": "All warehouses",
  "Pretraži sirovinu...": "Search ingredient...",
  "Osvježi": "Refresh",
  "Nema podataka o stanju": "No stock data",
  "{count} artikala": "{count} articles",
  "Ukupno kg": "Total kg",
  "Nema stavki": "No lines",
  "Niska zaliha": "Low stock",
  "QA odluka": "QA decision",
  "pušteno": "released",
  "odbijeno": "rejected",
  "dan proizvodnje ili ranije": "production day or earlier",
  "nema analize": "no analysis",
  "ne zadovoljava": "does not pass",
  "zadovoljava": "passes",
  "Stanje zaliha": "Stock levels",
  "Pretraži po sirovini...": "Search by ingredient...",
  "Prikaži neaktivne": "Show inactive",
  "Nema dostupnih zaliha": "No stock available",
  "Broj lota": "Lot number",
  "Deaktiviraj": "Deactivate",
  "Reaktiviraj": "Reactivate",
  "Odaberi proizvedeni lot za izvoz izvještaja.": "Select a produced lot to export the report.",
  "Izvoz izvještaja nije uspio: {message}": "Report export failed: {message}",
  "Odaberi proizvedeni lot za preuzimanje dokumentacije.": "Select a produced lot to download documentation.",
  "Preuzimanje dokumentacije nije uspjelo: {message}": "Documentation download failed: {message}",
  "nije otpremljeno": "not dispatched",
  "Nepoznat kupac": "Unknown customer",
  "Ulazni lot": "Inbound lot",
  "Lot još nije iskorišten u proizvodnji": "Lot has not been used in production yet",
  "Polu-proizvodi ({count})": "Semi-finished ({count})",
  "Polu-proizvod": "Semi-finished",
  "Proizvedeni lot ({count})": "Produced lot ({count})",
  "Polu-proizvod još nije ugrađen u gotovi proizvod": "Semi-finished product is not yet used in a finished product",
  "Proizvedeni lot · {count} zamjesa": "Produced lot · {count} mixes",
  "Glavni proizvod": "Main product",
  "{name} i još {count}": "{name} and {count} more",
  "preko: {names}": "via: {names}",
  "bez primke": "no receipt",
  "utrošak naloga": "order consumption",
  "Primke ({count})": "Receipts ({count})",
  "QA": "QA",
  "Kontrola kvalitete": "Quality control",
  "Ima odbijenih sirovina": "Has rejected ingredients",
  "{count} sirovina": "{count} ingredients",
  "nema evidentiranih lotova": "no recorded lots",
  "nema sirovina": "no ingredients",
  "odobreno {date} ili ranije": "approved {date} or earlier",
  "Međuskladišnice ({count})": "Transfers ({count})",
  "Pekara materijalno": "Bakery materials",
  "Ulazne sirovine": "Inbound ingredients",
  "skriveno {count}": "hidden {count}",
  "Nijedna ulazna sirovina nema primku": "No inbound ingredient has a receipt",
  "za polu-proizvod: {name}": "for semi-finished: {name}",
  "iz recepture": "from recipe",
  "{count} zamjesa u istom lotu": "{count} mixes in the same lot",
  "nema evidentiranih sirovina": "no recorded ingredients",
  "Polu-proizvod · iz recepture": "Semi-finished · from recipe",
  "nije proizveden kao nalog": "not produced as a work order",
  "Proizvedeni lot": "Produced lot",
  "Zamjes": "Mix",
  "{count} kom otpis": "{count} pcs write-off",
  "Analiza gotovog proizvoda": "Finished-product analysis",
  "Odredište ({count})": "Destination ({count})",
  "Izlaz gotovog": "Finished-goods outbound",
  "Kupci ({count})": "Customers ({count})",
  "kom/kg": "pcs/kg",
  "Klikni na bilo koji blok u dijagramu da vidiš detalje.": "Click any block in the diagram to see details.",
  "Ulazni lotovi, zamjesi, recepti, radni nalozi i otpremnice.": "Inbound lots, mixes, recipes, work orders and dispatch notes.",
  "Korišten u ({count})": "Used in ({count})",
  "Primljeno": "Received",
  "Utrošena količina": "Consumed quantity",
  "Primka {number}": "Receipt {number}",
  "Cijena/kg": "Price/kg",
  "Narudžba": "Order",
  "Bez povezane narudžbe": "No linked order",
  "Lot nije premještan među skladištima": "Lot has not been transferred between warehouses",
  "Međuskladišnica {number}": "Transfer {number}",
  "Iz skladišta": "From warehouse",
  "U skladište": "To warehouse",
  "Lot još nije iskorišten": "Lot not used yet",
  "Proizvedeni lot / zamjes": "Produced lot / mix",
  "Radni nalog": "Work order",
  "Recept ({count})": "Recipe ({count})",
  "Recept": "Recipe",
  "Sastav zamjesa ({count})": "Mix composition ({count})",
  "Otprema ({count})": "Dispatch ({count})",
  "— (nije dodijeljen)": "— (not assigned)",
  "Zamjes (MixCode)": "Mix (MixCode)",
  "Proizvedeno": "Produced",
  "Spakirano / odobreno": "Packed / released",
  "Otpis (škart)": "Write-off (scrap)",
  "Finalna masa": "Final mass",
  "Redoslijed": "Sequence",
  "Radni nalog {code}": "Work order {code}",
  "Potvrđen": "Confirmed",
  "Toga dana": "That day",
  "{orders} naloga, {batches} zamjesa": "{orders} orders, {batches} mixes",
  "Ostalo u istom nalogu ({count})": "Others in the same order ({count})",
  "Izlaz": "Outbound",
  "polu-proizvod": "semi-finished",
  "ovaj": "this",
  "Nije povezan radni nalog": "No linked work order",
  "Tijek izrade": "Production flow",
  "Nalog je uvezen iz Ritma, koji ne vodi vremena izrade ni strojeve — ta polja ostaju prazna.": "The order was imported from Ritam, which does not keep production times or machines — those fields stay empty.",
  "Mješalica": "Mixer",
  "Proces / linija": "Process / line",
  "Peć": "Oven",
  "Faza": "Phase",
  "Stroj": "Machine",
  "Početak": "Start",
  "Kraj": "End",
  "Min": "Min",
  "Bulk fermentacija": "Bulk fermentation",
  "Radnici (mij./obr./peč.)": "Workers (mix/proc/bake)",
  "Sastojci recepture": "Recipe ingredients",
  "Receptura nema definirane sastojke": "Recipe has no defined ingredients",
  "prilagodljivo": "adjustable",
  "Nije povezana receptura": "No linked recipe",
  "Još nije otpremljeno kupcima": "Not yet dispatched to customers",
  "Otpremnica": "Dispatch note",
  "Stavke ({count})": "Lines ({count})",
  "OIB": "PIN",
  "Potpisao": "Signed by",
  "Dokaz o dostavi 📎": "Proof of delivery 📎",
  "Otpremnica nema stavki": "Dispatch note has no lines",
  "Narudžbenica": "Purchase order",
  "Međuskladišnica": "Inter-warehouse transfer",
  "Od": "From",
  "Od:": "From:",
  "Na": "To",
  "Međuskladišnica nema stavki": "Transfer has no lines",
  "Odobrenje na dan proizvodnje ili ranije": "Approval on production day or earlier",
  "Odobreno": "Approved",
  "Izvor": "Source",
  "Odjel proizvodnje": "Production department",
  "Miris": "Smell",
  "Okus": "Taste",
  "Izgled": "Appearance",
  "Težina": "Weight",
  "Volumen proizvoda": "Product volume",
  "Duljina": "Length",
  "Širina": "Width",
  "Visina": "Height",
  "Zadovoljava": "Passes",
  "Provjera deklaracije": "Label check",
  "Kontrolirao": "Checked by",
  "Nesukladnost / reklamacija": "Nonconformity / complaint",
  "nema unosa": "no entry",
  "Još nema unosa za ovaj lot — polja su iz dnevne kontrole gotovog proizvoda.": "No entry yet for this lot — fields come from daily finished-product control.",
  "Sljedivost lota": "Lot traceability",
  "Napredno": "Advanced",
  "samo s primkom": "only with receipt",
  "prikaži skrivene proizvode": "show hidden products",
  "Pripremam izvještaj…": "Preparing report…",
  "Izvezi izvještaj": "Export report",
  "Pripremam dokumentaciju…": "Preparing documentation…",
  "Preuzmi dokumentaciju": "Download documentation",
  "Unaprijed · ulazni lot → kupac": "Forward · inbound lot → customer",
  "Unatrag · proizvedeni lot → sirovine": "Backward · produced lot → ingredients",
  "{count} zamjesa": "{count} mixes",
  "Dijagram sljedivosti": "Traceability diagram",
  "QA sirovine": "Ingredient QA",
  "QA gotov": "Finished QA",
  "Zatvori detalj": "Close detail",
  "Učitavanje skladišta: {message}": "Loading warehouses: {message}",
  "Učitavanje sirovina: {message}": "Loading ingredients: {message}",
  "Učitavanje Ritam sirovina: {message}": "Loading Ritam ingredients: {message}",
  "Učitavanje dostava: {message}": "Loading deliveries: {message}",
  "Sirovina (Ritam) i količina su obavezni": "Ingredient (Ritam) and quantity are required",
  "Odaberite skladište na koje ide zaliha": "Select the warehouse that receives the stock",
  "Dostava registrirana — stavka je u karanteni i čeka odobrenje.": "Delivery registered — the line is in quarantine pending approval.",
  "Pušten": "Released",
  "+ Jedna stavka": "+ Single line",
  "+ Grupna dostava": "+ Group delivery",
  "Povijest primki": "Receipt history",
  "Nema registriranih dostava": "No registered deliveries",
  "Broj stavki koje čekaju odobrenje": "Number of lines awaiting approval",
  "Lot {number}": "Lot {number}",
  "Sirovina (Ritam)": "Ingredient (Ritam)",
  "LOT": "LOT",
  "Kg": "Kg",
  "Preostalo": "Remaining",
  "Odobravanje u Kvaliteti →": "Approval in Quality →",
  "primki": "receipts",
  "Jedna stavka": "Single line",
  "Sirovina (Ritam) *": "Ingredient (Ritam) *",
  "Pretraži Ritam sirovine...": "Search Ritam ingredients...",
  "Pretraži sirovine...": "Search ingredients...",
  "Datum *": "Date *",
  "Količina (kg) *": "Quantity (kg) *",
  "Skladište *": "Warehouse *",
  "-- Odaberi skladište --": "-- Select warehouse --",
  "Greška kod učitavanja otpremnica: {message}": "Error loading dispatch notes: {message}",
  "Odaberi kupca": "Select customer",
  "Dodaj barem jedan proizvedeni lot": "Add at least one produced lot",
  "Otpremnica kreirana": "Dispatch note created",
  "Greška kod spremanja: {message}": "Error saving: {message}",
  "+ Nova otpremnica": "+ New dispatch note",
  "Nova otpremnica": "New dispatch note",
  "-- Odaberi kupca --": "-- Select customer --",
  "Stavke (proizvedeni lotovi)": "Lines (produced lots)",
  "-- Odaberi lot --": "-- Select lot --",
  "+ Dodaj stavku": "+ Add line",
  "Spremi otpremnicu": "Save dispatch note",
  "Još nema otpremnica": "No dispatch notes yet",
  "PDV ID broj": "VAT ID",
  "{kind} br.{number}": "{kind} no.{number}",
  "Oblik: Standardni": "Form: Standard",
  "Kalkulirao:": "Calculated by:",
  "Odobrio:": "Approved by:",
  "lot {lot}": "lot {lot}",
  "Sastavnica": "Bill of materials",
  "Otpremnica (sken)": "Dispatch note (scan)",
  "Radni nalog · poluproizvod": "Work order · semi-finished",
  "Izlazne međuskladišnice": "Outbound transfers",
  "otpis": "write-off",
  "gotovi proizvodi": "finished goods",
  "izlaz": "outbound",
  "Dokumentacija sljedivosti": "Traceability documentation",
  "Proizvod:": "Product:",
  "Lot:": "Lot:",
  "Datum proizvodnje:": "Production date:",
  "Izrađeno:": "Issued:",
  "Dokumenti su grupirani po sastavnici (otpremnica → primka → ulazna međuskladišnica). Radni nalozi i izlazne međuskladišnice su na kraju. Cijene i PDV nisu dio ovog izvoda.": "Documents are grouped by bill of materials (dispatch note → receipt → inbound transfer). Work orders and outbound transfers are at the end. Prices and VAT are not part of this extract.",
  "Vrsta": "Type",
  "{n} kom proizvedeno": "{n} pcs produced",
  "{n} kom spakirano": "{n} pcs packed",
  "Lot / šifra:": "Lot / code:",
  "Datum:": "Date:",
  "Receptura:": "Recipe:",
  "Količina:": "Quantity:",
  "Trajanje": "Duration",
  "Nema evidentiranih faza": "No recorded phases",
  "Nema utrošenih sirovina": "No consumed ingredients",
  "Primka br.{number}": "Receipt no.{number}",
  "Radna jedinica:": "Work unit:",
  "Dobavljač:": "Supplier:",
  "OIB dobavljača:": "Supplier PIN:",
  "Dokument dobavljača:": "Supplier document:",
  "Dokument dobavljača": "Supplier document",
  "Isporuka:": "Delivery:",
  "Broj:": "Number:",
  "Tip računa:": "Invoice type:",
  "Izlaz · otpis": "Outbound · write-off",
  "Izlaz · gotovi proizvodi": "Outbound · finished goods",
  "Ulazna međuskladišnica": "Inbound transfer",
  "Međuskladišnica br.{number}": "Transfer no.{number}",
  "Iz skladišta:": "From warehouse:",
  "U skladište:": "To warehouse:",
  "Izradio:": "Created by:",
  "Primka:": "Receipt:",
  "Dokumentacija · {lot}": "Documentation · {lot}",
  "Što je proizvedeno (zapakirano) i koliko je na stanju": "What was produced (packed) and how much is in stock",
  "u skladištu: {name}": "in warehouse: {name}",
  "Pretraži proizvod...": "Search product...",
  "Do:": "To:",
  "Nema proizvedenih gotovih proizvoda na stanju": "No produced finished goods in stock",
  "skladište:": "warehouse:",
  "Proizvod #{id}": "Product #{id}",
  "{count} zamjes": "{count} mixes",
  "{count} kom": "{count} pcs",
  "Proizvodni LOT": "Production LOT",
  "Komada": "Pieces",
  "Masa (kg)": "Mass (kg)",
  "1. tijesto": "1st dough",
  "2. tijesto": "2nd dough",
  "Preljev": "Topping",
  "Posip": "Sprinkle",
  "Receptura": "Recipe",
  "Spremno": "Ready",
  "Pauza": "On hold",
  "Izvještaj o sljedivosti": "Traceability report",
  "IZVJEŠTAJ O SLJEDIVOSTI PROIZVODNE SERIJE": "PRODUCTION BATCH TRACEABILITY REPORT",
  "Identifikacija proizvodne serije": "Production batch identification",
  "Proizvedeni LOT": "Produced LOT",
  "Šifra zamjesa (MixCode)": "Mix code (MixCode)",
  ", verzija {version}": ", version {version}",
  "nije povezana": "not linked",
  "Mikser / peć": "Mixer / oven",
  "Spakirano / odobreno (GP)": "Packed / released (FG)",
  "Masa tijesta": "Dough mass",
  "Status serije": "Batch status",
  "Razina 2 — poluproizvodi": "Level 2 — semi-finished",
  "Razina 3 — zamjes": "Level 3 — mix",
  "Razina 4 — proizvedeni lot": "Level 4 — produced lot",
  "proizvedeno": "produced",
  "odobreno": "approved",
  "Razina 5 — izlaz gotovog": "Level 5 — finished-goods outbound",
  "skladište": "warehouse",
  "Razina {n} — otprema": "Level {n} — dispatch",
  "kupac": "customer",
  "Registar ulaznih sirovina": "Inbound ingredient register",
  "Interni poluproizvod": "Internal semi-finished",
  "Prijem i rok trajanja": "Receipt and expiry",
  "Bez primke": "No receipt",
  "Za ovaj proizvod nije povezana receptura u MES-u.": "No recipe is linked to this product in MES.",
  "Procesni parametri po fazama": "Process parameters by phase",
  "Procesne faze nisu definirane za ovaj proizvod.": "Process phases are not defined for this product.",
  "Plan": "Plan",
  "T plan": "T plan",
  "Ostvareno": "Actual",
  "QA gotovog proizvoda": "Finished-product QA",
  "Odjel": "Department",
  "Volumen (cm)": "Volume (cm)",
  "D {l} · Š {w} · V {h}": "L {l} · W {w} · H {h}",
  "Deklaracija": "Label",
  "Nesukladnost": "Nonconformity",
  "Izlaz gotovog proizvoda": "Finished-goods outbound",
  "↳ Oblik": "↳ Shape",
  "škart zbog oblika": "scrap due to shape",
  "↳ Boja": "↳ Colour",
  "škart zbog boje": "scrap due to colour",
  "Odobreno ide u skladište gotovih proizvoda; škart u skladište otpisa. Količine su s međuskladišnice (kom iz težine komada).": "Approved goods go to the finished-goods warehouse; scrap goes to write-off. Quantities come from the transfer (pcs from piece weight).",
  "Otprema": "Dispatch",
  "Serija još nije otpremljena.": "The batch has not been dispatched yet.",
  "Izvještaj o sljedivosti izrađen iz Poweriot MES sustava. Obuhvaća sljedivost unatrag (proizvedeni lot → ulazne sirovine) za jednu proizvodnu seriju. HACCP kontrolne točke nisu dio ovog izvoda.": "Traceability report generated from the Poweriot MES. It covers backward traceability (produced lot → inbound ingredients) for one production batch. HACCP control points are not part of this extract.",
  "Preglednik je blokirao novi prozor. Dozvolite pop-up za izvoz izvještaja.": "The browser blocked a new window. Allow pop-ups to export the report.",
  "Priprema izvještaja…": "Preparing report…",
  "Nema promjena za spremanje": "No changes to save",
  "Popis spremljen": "Count saved",
  "Nema praznih stavki sa stanjem": "No empty lines with stock",
  "Popunjeno {count} stavki — provjerite i ispravite odstupanja": "Filled {count} lines — review and correct differences",
  "Popišite barem jednu stavku prije knjiženja": "Count at least one line before posting",
  "Proknjižiti inventuru {number}?\n\nPopisano: {counted} / {total} stavki\nViškovi: +{surplus} kg\nManjkovi: -{shortage} kg\n\nStanje skladišta bit će usklađeno s popisanim količinama. Nepopisane stavke ostaju nepromijenjene.": "Post stocktake {number}?\n\nCounted: {counted} / {total} lines\nSurplus: +{surplus} kg\nShortage: -{shortage} kg\n\nWarehouse stock will be aligned to counted quantities. Uncounted lines stay unchanged.",
  "Inventura proknjižena — stanje usklađeno": "Stocktake posted — stock aligned",
  "Otkazati inventuru {number}? Popis se neće proknjižiti.": "Cancel stocktake {number}? The count will not be posted.",
  "Inventura otkazana": "Stocktake cancelled",
  "Popis stvarnog stanja skladišta i knjiženje razlika. Koristi se i za inicijalni unos zaliha kad se skladište tek pušta u rad.": "Physical warehouse count and posting of differences. Also used for initial stock when a warehouse is first put into use.",
  "+ Nova inventura": "+ New stocktake",
  "Svi statusi": "All statuses",
  "Nema inventura. Otvorite novu da popišete stanje ili unesete početne zalihe.": "No stocktakes. Open a new one to count stock or enter opening quantities.",
  "Popisano": "Counted",
  "Višak (kg)": "Surplus (kg)",
  "Manjak (kg)": "Shortage (kg)",
  "Razlika (€)": "Difference (€)",
  "Popiši": "Count",
  "proknjižena {date}": "posted {date}",
  "← Sve inventure": "← All stocktakes",
  "Viškovi": "Surplus",
  "Manjkovi": "Shortages",
  "Vrijednost razlike": "Difference value",
  "Pretraži stavku ili LOT...": "Search line or LOT...",
  "Sve stavke": "All lines",
  "Nepopisane": "Uncounted",
  "Samo razlike": "Differences only",
  "Bez knjigovodstvenog stanja": "No book stock",
  "Popuni stanjem": "Fill with stock",
  "Prikazano {shown} od {total}": "Showing {shown} of {total}",
  "Stanje (kg)": "Stock (kg)",
  "Popisano (kg)": "Counted (kg)",
  "Razlika": "Difference",
  "Razlog": "Reason",
  "Nema stavki za prikaz": "No lines to display",
  "novi LOT": "new LOT",
  "Ukloni stavku iz popisa": "Remove line from count",
  "Otkaži inventuru": "Cancel stocktake",
  "Spremi popis ({count})": "Save count ({count})",
  "Spremi popis": "Save count",
  "Proknjiži inventuru": "Post stocktake",
  "Odaberite skladište": "Select warehouse",
  "Inventura {number} otvorena": "Stocktake {number} opened",
  "Nova inventura": "New stocktake",
  "Datum popisa *": "Count date *",
  "Vrsta popisa": "Count type",
  "Izlistava cijeli šifrarnik sirovina, ambalaže i repromaterijala s nultim stanjem — upišete samo količine koje su fizički u skladištu.": "Lists the full catalog of ingredients, packaging and supplies with zero stock — enter only quantities physically in the warehouse.",
  "Popisuju se LOT-ovi koji trenutno imaju stanje na skladištu.": "Lots that currently have warehouse stock are counted.",
  "Dodaj i artikle bez stanja (za naknadni unos zatečene robe)": "Also add articles without stock (for later entry of found goods)",
  "Otvaranje...": "Opening...",
  "Otvori popis": "Open count",
  "Odaberite stavku": "Select a line",
  "Neispravna količina": "Invalid quantity",
  "Stavka dodana": "Line added",
  "Dodaj stavku u popis": "Add line to count",
  "Stavka *": "Line *",
  "Pretraži sirovine, ambalažu i repro...": "Search ingredients, packaging and supplies...",
  "LOT / šarža": "LOT / batch",
  "Broj s ambalaže": "Number from packaging",
  "Popisana količina (kg)": "Counted quantity (kg)",
  "Nabavna cijena (€/kg)": "Purchase price (€/kg)",
  "Razlog odstupanja": "Reason for difference",
  "Knjiženjem inventure za ovu stavku se otvara novi LOT s popisanom količinom.": "Posting the stocktake for this line opens a new LOT with the counted quantity.",
  "Dodavanje...": "Adding...",
  "Planirana": "Planned",
  "U popisu": "Counting",
  "Usklađivanje": "Reconciling",
  "Proknjižena": "Posted",
  "Otkazana": "Cancelled",
  "Mjesečna": "Monthly",
  "Ciklička": "Cycle",
  "Kontrolna": "Spot check",
  "Godišnja": "Annual",
  "Inicijalni unos": "Initial stock",
  "Popis skladišta nije učitan": "Warehouse list failed to load",
  "Objavljeno skladištaru: {number}": "Published to warehouse operator: {number}",
  "Odaberite početno i odredišno skladište": "Select source and destination warehouse",
  "Početno i odredišno skladište moraju biti različiti": "Source and destination warehouses must be different",
  "Odaberite lot i upišite količinu za barem jednu stavku": "Select a lot and enter quantity for at least one line",
  "Količina prelazi zalihu lota ({name}: {remaining})": "Quantity exceeds lot stock ({name}: {remaining})",
  "Nacrt {number}": "Draft {number}",
  "Kreirano: {number}": "Created: {number}",
  "Objavljeno skladištaru": "Published to warehouse operator",
  "Otkazati međuskladišnicu?": "Cancel the transfer?",
  "Označite sve stavke prije završetka": "Mark all lines before completing",
  "Završiti međuskladišnicu i knjižiti prenesene količine?": "Complete the transfer and post transferred quantities?",
  "Označeno kao preneseno": "Marked as transferred",
  "Preneseno:": "Transferred:",
  "stavki": "lines",
  "(nema stavki za prijenos)": "(no lines to transfer)",
  "Prenijeti": "To transfer",
  "Potrebno": "Required",
  "Označite kad prenesete u proizvodnju": "Tick when transferred to production",
  "Stavka nema ID": "Line has no ID",
  "Nema potrebe za prijenosom": "No transfer needed",
  "Označite svaku prenesenu stavku (✓). Žuti redovi: nema LOT-a u sustavu — prenesite ručno prema \"Potrebno\" kg.": "Tick each transferred line (✓). Yellow rows: no LOT in the system — transfer manually using the \"Required\" kg.",
  "Voditelj proizvodnje — kreiraj i objavi listu za skladište": "Production manager — create and publish the warehouse list",
  "Skladištar — pregled i potvrda prijenosa za odabrani dan": "Warehouse operator — review and confirm transfers for the selected day",
  "Skladištar": "Warehouse operator",
  "Voditelj": "Manager",
  "Dan": "Day",
  "{count} za prijenos": "{count} to transfer",
  "+ Nova međuskladišnica": "+ New transfer",
  "Nema međuskladišnica koje čekaju prijenos za {date}": "No transfers awaiting movement for {date}",
  "Nema međuskladišnica koje čekaju prijenos": "No transfers awaiting movement",
  "Za prijenos": "To transfer",
  "{count} stavki": "{count} lines",
  "Plan v{version}": "Plan v{version}",
  "Prikaži stavke": "Show lines",
  "za prijenos": "to transfer",
  "Završi međuskladišnicu": "Complete transfer",
  "+ Ručna": "+ Manual",
  "+ Iz plana": "+ From plan",
  "Nema međuskladišnica": "No transfers",
  "Ruta": "Route",
  "dokumenata": "documents",
  "Detalji": "Details",
  "Odaberite dokument": "Select a document",
  "Objavi skladištaru": "Publish to warehouse operator",
  "Skladištar: {done}/{total} preneseno": "Warehouse: {done}/{total} transferred",
  "Iz plana proizvodnje": "From production plan",
  "Pregled (FEFO)": "Preview (FEFO)",
  "{batches} zamjesa · {ingredients} sirovina": "{batches} mixes · {ingredients} ingredients",
  "Ručna međuskladišnica": "Manual transfer",
  "Iz skladišta *": "From warehouse *",
  "U skladište *": "To warehouse *",
  "+ Stavka": "+ Line",
  "Odaberite početno skladište da vidite dostupne lotove": "Select a source warehouse to see available lots",
  "Odabrano skladište nema zaliha za prijenos": "Selected warehouse has no stock to transfer",
  "Materijal / LOT": "Material / LOT",
  "{name} — {lot} (stanje {remaining})": "{name} — {lot} (stock {remaining})",
  "Kg (max {remaining})": "Kg (max {remaining})",
  "Spremi nacrt": "Save draft",
  "Kreiraj i otvori listu": "Create and open list",
  "Čeka prijenos": "Awaiting transfer",
  "U prijenosu": "In transit",
  "Preneseno": "Transferred",
  "Prepoznat je primatelj (Boogie Bakery) — odaberite pravog dobavljača s otpremnice": "The recipient (Boogie Bakery) was detected — select the actual supplier from the dispatch note",
  "Otpremnica prepoznata — provjerite podatke": "Dispatch note recognised — check the data",
  "Greška pri čitanju otpremnice": "Error reading dispatch note",
  "LOT: {number}": "LOT: {number}",
  "LOT nije prepoznat — unesite ručno": "LOT not recognised — enter it manually",
  "Greška pri čitanju etikete": "Error reading label",
  "Unesite broj otpremnice": "Enter the dispatch note number",
  "Odaberite ili unesite dobavljača": "Select or enter a supplier",
  "Boogie Bakery je primatelj — unesite dobavljača s otpremnice": "Boogie Bakery is the recipient — enter the supplier from the dispatch note",
  "Svaka stavka mora imati odabranu sirovinu (Ritam)": "Each line must have a selected ingredient (Ritam)",
  "Svaka stavka mora imati količinu (kg)": "Each line must have a quantity (kg)",
  "Grupna dostava registrirana — brašno u karanteni (QC), ostalo odmah u zalihu.": "Group delivery registered — flour in quarantine (QC), other items immediately in stock.",
  "Grupna dostava registrirana.": "Group delivery registered.",
  "Spremanje nije uspjelo": "Save failed",
  "Čitanje otpremnice...": "Reading dispatch note...",
  "Čitanje LOT etikete...": "Reading LOT label...",
  "Grupna dostava": "Group delivery",
  "Odaberite način unosa": "Choose entry mode",
  "Pregled s otpremnice": "Review from dispatch note",
  "Ručni unos stavki": "Manual line entry",
  "Pregled prije spremanja": "Review before save",
  "Ručni unos": "Manual entry",
  "Dodajte stavke jednu po jednu": "Add lines one by one",
  "Skeniraj otpremnicu": "Scan dispatch note",
  "Slikaj ili učitaj — AI prepoznaje stavke": "Photograph or upload — AI recognises lines",
  "Slika otpremnice": "Dispatch note image",
  "Datum primitka": "Receipt date",
  "Zaliha se knjiži na odabrano skladište.": "Stock is posted to the selected warehouse.",
  "— Odaberi iz baze —": "— Select from catalog —",
  "Naziv dobavljača (s otpremnice)": "Supplier name (from dispatch note)",
  "Ako nije u listi": "If not on the list",
  "OIB dobavljača": "Supplier PIN",
  "Slika otpremnice (opcionalno)": "Dispatch note image (optional)",
  "Stavka {n}": "Line {n}",
  "Ukloni": "Remove",
  "S otpremnice": "From dispatch note",
  "nije odabrano": "not selected",
  "Slikaj LOT etiketu": "Photograph LOT label",
  "Etiketa / LOT": "Label / LOT",
  "Spremi grupnu dostavu": "Save group delivery",
  "otvori original": "open original",
  "zatvori": "close",
  "📷 Slikaj": "📷 Photograph",
  "📁 Učitaj": "📁 Upload",

  // MES Planning / Execution / Monitoring / Reports / components
  "bez dobavljača": "no supplier",
  " · rok {date}": " · due {date}",
  "bez knjižene zalihe": "no booked stock",
  "nema zalihe": "no stock",
  "drugo skladište": "other warehouse",
  "Nepoznat proizvod": "Unknown product",
  "Nepoznata sirovina": "Unknown ingredient",
  "Greška pri učitavanju receptura: {message}": "Error loading recipes: {message}",
  "Lotovi dodijeljeni po FEFO logici, zaliha pekare ima prednost": "Lots assigned by FEFO; bakery stock takes priority",
  "Međuskladišnica{number} kreirana ({count} stavki)": "Transfer{number} created ({count} lines)",
  "Dodjela lotova je spremljena, ali međuskladišnica nije kreirana: {message}": "Lot assignment saved, but the transfer was not created: {message}",
  "{count} stavki bez dodijeljenog lota": "{count} lines without an assigned lot",
  "Dodjela lotova spremljena": "Lot assignment saved",
  "Spremanje dodjele lotova nije uspjelo: {message}": "Saving lot assignment failed: {message}",
  "⚠ Nema dostupnih lotova": "⚠ No lots available",
  "-- Različiti lotovi --": "-- Different lots --",
  "Po zamjesu": "By mix",
  "Nedodijeljeno": "Unassigned",
  "⚠ Nedovoljna zaliha": "⚠ Insufficient stock",
  "Zaliha je na centralnom skladištu — treba je prenijeti u pekaru međuskladišnicom": "Stock is at the central warehouse — transfer it to the bakery",
  "⇄ Centralno": "⇄ Central",
  "Zaliha nije ni u pekari ni na centralnom skladištu, nego na {warehouse}": "Stock is neither in the bakery nor at central, but at {warehouse}",
  "drugom skladištu": "another warehouse",
  "⚠ Na {warehouse}": "⚠ At {warehouse}",
  "Za ovaj lot nema nijednog knjiženja na skladište, pa mu se stanje ne može izračunati. Zaliha možda fizički postoji — provjeri sa skladištarom.": "This lot has no warehouse postings, so its balance cannot be calculated. Stock may still exist physically — check with the warehouse.",
  "Lot ima knjiženja, ali ni na jednom skladištu nema preostale zalihe": "The lot has postings, but no warehouse has remaining stock",
  "⚠ Bez knjižene zalihe": "⚠ No booked stock",
  "⚠ Nema zalihe": "⚠ No stock",
  "Materijal": "Material",
  "Potrebno (kg)": "Required (kg)",
  "Potrebno ukupno": "Total required",
  "Potrebno ukupno (kg)": "Total required (kg)",
  "Lot (za sve zamjese)": "Lot (for all mixes)",
  "Učitavanje receptura i lotova…": "Loading recipes and lots…",
  "Dodjela lotova sirovina": "Ingredient lot assignment",
  "Lot se prema zadanom bira jednom po proizvodu i primjenjuje na sve njegove zamjese. Uključi": "By default a lot is chosen once per product and applied to all its mixes. Enable",
  "za proizvod kojem želiš dodijeliti različite sirovine po zamjesu. Prvo se nude lotovi iz pekare, a zatim oni s centralnog skladišta.": "for a product where you want different ingredients per mix. Bakery lots are offered first, then central-warehouse lots.",
  "Uz sirovine zamjesa potvrđuju se i": "Along with mix ingredients, also confirm",
  "dodatne sirovine po fazi": "extra ingredients by phase",
  "(repro i ambalaža) s količinom iz normativa proizvoda.": "(rework and packaging) with quantities from the product BOM.",
  "Automatski (FEFO)": "Automatic (FEFO)",
  "⚠ Bez recepture: {list} — za te zamjese lotovi se ne mogu dodijeliti.": "⚠ No recipe: {list} — lots cannot be assigned for those mixes.",
  "Nema sirovina za dodjelu lotova": "No ingredients to assign lots to",
  "Receptura {recipe} · {count} zamjesa": "Recipe {recipe} · {count} mixes",
  "Dodatne sirovine po fazi": "Extra ingredients by phase",
  "repro i ambalaža iz normativa proizvoda": "rework and packaging from the product BOM",
  "Kreiraj međuskladišnicu iz": "Create transfer from",
  "u": "to",
  "Na centralnom skladištu je {from} od {total} dodijeljenih lotova. Bez prijenosa ih skladištar ne može izdati u zamjes. Odznači stavku koju ne želiš na međuskladišnici.": "{from} of {total} assigned lots are at the central warehouse. Without a transfer the storekeeper cannot issue them into the mix. Uncheck a line you do not want on the transfer.",
  "Za prijenos (kg)": "To transfer (kg)",
  "Na centralnom (kg)": "At central (kg)",
  "Zamjese": "Mixes",
  "Nedostaje {kg} kg na centralnom skladištu": "{kg} kg short at the central warehouse",
  "{count} nedodijeljenih stavki": "{count} unassigned lines",
  "Sve stavke imaju lot": "All lines have a lot",
  "{count} bez zalihe (preskače se)": "{count} with no stock (skipped)",
  "međuskladišnica sa {count} stavki": "transfer with {count} lines",
  "Spremanje…": "Saving…",
  "Potvrdi i spremi": "Confirm and save",
  "Odaberi barem jedan zamjes za slanje u NOĆ.": "Select at least one mix to send to NIGHT.",
  "Upisi razlog intervencije prije primjene.": "Enter a reason before applying the intervention.",
  "Nema aktivnih zamjesa za izmjenu.": "No active mixes to change.",
  "Prikazano {active} od {total} zamjesa — {hidden} {frozen} ({summary}) i ne moze im se mijenjati redoslijed: ": "Showing {active} of {total} mixes — {hidden} {frozen} ({summary}) and their order cannot be changed: ",
  "je zamrznut": "is frozen",
  "su zamrznuti": "are frozen",
  "Operativna izmjena redoslijeda": "Operational reorder",
  "Promijeni redoslijed preostalih (aktivnih) zamjesa u hodu. Zavrsene i zamjese u tijeku ostaju nepromijenjene. Potvrdeni plan ostaje sacuvan u bazi — svaka promjena se biljezi s razlogom.": "Change the order of remaining (active) mixes in flight. Completed and in-progress mixes stay unchanged. The confirmed plan stays in the database — every change is logged with a reason.",
  "Pošalji označene zamjese na kraj rasporeda ovog miksera (NOĆ)": "Send selected mixes to the end of this mixer's schedule (NIGHT)",
  "Pošalji u NOĆ": "Send to NIGHT",
  "NOĆ": "NIGHT",
  "Novi redoslijed": "New order",
  "ID zamjesa": "Mix ID",
  "Start mij.": "Mix start",
  "Kraj pec.": "Bake end",
  "Označi za slanje u NOĆ": "Mark to send to NIGHT",
  "Razlog intervencije (obavezno)": "Intervention reason (required)",
  "Primijeni operativnu izmjenu": "Apply operational change",
  "Greška pri preračunu rasporeda: {message}": "Error recalculating the schedule: {message}",
  "Raspored ažuriran. Spremi draft za sinkronizaciju s bazom.": "Schedule updated. Save the draft to sync with the database.",
  "Raspored ažuriran. Spremi plan za sinkronizaciju s bazom.": "Schedule updated. Save the plan to sync with the database.",
  "Raspored preračunat": "Schedule recalculated",
  "Greška pri ažuriranju rasporeda: {message}": "Error updating the schedule: {message}",
  "Uređivanje plana — promijeni proizvode i raspored, zatim potvrdi novu reviziju": "Edit plan — change products and schedule, then confirm a new revision",
  "Nema zamjesa za spremiti": "No mixes to save",
  "Izmjena plana": "Plan change",
  "Nova revizija potvrđena (verzija {version})": "New revision confirmed (version {version})",
  "Greška pri reviziji: {message}": "Error confirming revision: {message}",
  "Status zamjesa ažuriran": "Mix status updated",
  "Greška pri promjeni statusa: {message}": "Error changing status: {message}",
  "Operativna izmjena primijenjena": "Operational change applied",
  "Greška pri operativnoj izmjeni: {message}": "Error applying operational change: {message}",
  "Dan počinje u {value}": "Day starts at {value}",
  "Vraćeno na globalnu postavku": "Reverted to the global setting",
  "Greška pri promjeni početka dana: {message}": "Error changing day start: {message}",
  "Dodajte barem jedan proizvod u plan": "Add at least one product to the plan",
  "Timeline generiran": "Timeline generated",
  "Lotovi dodijeljeni potvrđenom planu": "Lots assigned to the confirmed plan",
  "Tablica": "Table",
  "ID Zamjesa": "Mix ID",
  "Mikser": "Mixer",
  "Pećnica": "Oven",
  "Broj ljudi: miješanje / obrada / pečenje": "People: mixing / processing / baking",
  "Ljudi (M/O/P)": "People (M/P/B)",
  "Pocetak": "Start",
  "Proizvodnja na ovaj dan": "Production on this day",
  " · {count} polugotovih za druge dane": " · {count} semi-finished for other days",
  " · {count} višednevnih": " · {count} multi-day",
  "Sve što se fizički radi {date} — uključuje faze višednevnih zamjesa (npr. prvo miješanje jedan dan, pakiranje drugi) i polugotove namijenjene drugim danima.": "Everything physically done on {date} — includes phases of multi-day mixes (e.g. first mix one day, packing the next) and semi-finished goods meant for other days.",
  "Faze {date}": "Phases {date}",
  "Faze danas": "Phases today",
  "Polugotov": "Semi-fin.",
  "Gotov": "Finished",
  "za {date}": "for {date}",
  "nastavak · plan {date}": "continuation · plan {date}",
  "Plan {date}:": "Plan {date}:",
  " — prikaz faza za {date}": " — showing phases for {date}",
  " (verzija {version})": " (version {version})",
  "1. Definiranje proizvoda": "1. Define products",
  "Odaberi proizvode, broj zamjesa, masu, uređaje (mikser / obrada / pećnica) i broj ljudi po fazi.": "Select products, mix count, mass, equipment (mixer / processing / oven) and people per phase.",
  "Početak dana (prvo miješanje)": "Day start (first mixing)",
  "Vrijedi samo za {date}.": "Applies only to {date}.",
  "Zadano: {time} (globalna postavka).": "Default: {time} (global setting).",
  "Vrati na zadano": "Reset to default",
  "Broj zamjesa": "Number of mixes",
  "Broj ljudi za miješanje": "People for mixing",
  "Ljudi miješanje": "Mixing people",
  "Broj ljudi za obradu": "People for processing",
  "Ljudi obrada": "Processing people",
  "Broj ljudi za pečenje": "People for baking",
  "Ljudi pečenje": "Baking people",
  "Odaberi proizvod": "Select product",
  "+ Dodaj red": "+ Add row",
  "Dalje: Polugotovi →": "Next: Semi-finished →",
  "← Natrag": "← Back",
  "Dalje: Raspored →": "Next: Schedule →",
  "3. Uređivanje rasporeda": "3. Edit schedule",
  "Opcionalna pravila redoslijeda (prioritet / noć / cik-cak). Nakon izmjene pravila regeneriraj raspored.": "Optional order rules (priority / night / zigzag). After changing rules, regenerate the schedule.",
  "↻ Regeneriraj raspored": "↻ Regenerate schedule",
  "Dalje: Gantt →": "Next: Gantt →",
  "4. Gantt — {date}": "4. Gantt — {date}",
  "Prikazani su zamjesi koji se rade na {date}. {count} polugotovih zamjesa raspoređeno je na druge dane (vidi „Polugotovi proizvodi\").": "Showing mixes made on {date}. {count} semi-finished mixes are scheduled on other days (see “Semi-finished products”).",
  "Odustani od izmjene": "Discard changes",
  "Potvrdi izmjene (nova revizija)": "Confirm changes (new revision)",
  "Spremi kao draft": "Save as draft",
  "Potvrdi timeline": "Confirm timeline",
  "Potvrđeni plan": "Confirmed plan",
  "Plan je potvrđen (verzija {version}). Promijeni status zamjesa ili napravi operativnu izmjenu redoslijeda u hodu; za veće izmjene (dodavanje, uklanjanje ili promjena proizvoda) uredi plan i potvrdi novu reviziju.": "The plan is confirmed (version {version}). Change mix status or apply an operational reorder on the fly; for larger changes (add, remove or change products) edit the plan and confirm a new revision.",
  "Dodijeli lotove": "Assign lots",
  "Razlog revizije (opcionalno)": "Revision reason (optional)",
  "Izmijeni plan (nova revizija)": "Edit plan (new revision)",
  "Timeline — faze za {date}": "Timeline — phases for {date}",
  "Zatvori sidebar": "Close product sidebar",
  "Pretrazi proizvode...": "Search products...",
  "Otvori sidebar proizvoda": "Open product sidebar",
  "POTVRDI TIMELINE": "CONFIRM TIMELINE",
  "Potvrda plana proizvodnje": "Confirm production plan",
  "Zelite li dodijeliti lotove sirovinama prije potvrde?": "Do you want to assign lots to ingredients before confirming?",
  "Napomene (opcionalno)": "Notes (optional)",
  "Unesite dodatne napomene...": "Enter extra notes...",
  "Potvrdjivanje...": "Confirming...",
  "Potvrdi bez lotova": "Confirm without lots",
  "Potvrdi s lotovima": "Confirm with lots",
  "DODIJELI LOTOVE": "ASSIGN LOTS",
  "{weekday} · isti dan": "{weekday} · same day",
  "{weekday} · dan prije": "{weekday} · day before",
  "{weekday} · {delta} dana prije": "{weekday} · {delta} days before",
  "{weekday} · {delta} dana kasnije": "{weekday} · {delta} days later",
  "2. Polugotovi proizvodi": "2. Semi-finished products",
  "Starteri, enzimi i mješavine sjemena rijetko se rade isti dan kao gotovi proizvodi. Datum proizvodnje predložen je iz pravila (npr. starter dan prije, enzimi petak) — po potrebi izmijeni.": "Starters, enzymes and seed mixes are rarely made on the same day as finished goods. The production date is suggested from the rule (e.g. starter the day before, enzymes Friday) — change it if needed.",
  "Odabrani proizvodi nemaju polugotovih proizvoda u recepturi.": "The selected products have no semi-finished goods in the recipe.",
  "Polugotov proizvod": "Semi-finished product",
  "Ukupna masa (kg)": "Total mass (kg)",
  "Dan proizvodnje": "Production day",
  "Odnos na gotov proizvod": "Relative to finished product",
  "Smjena:": "Shift:",
  "Odaberi smjenu": "Select shift",
  "Dostupno osoblje ({count})": "Available staff ({count})",
  "Svo osoblje dodijeljeno za ovu smjenu": "All staff assigned for this shift",
  "Raspodjela po strojevima": "Allocation by machine",
  "Povuci osoblje ovdje": "Drop staff here",
  "⚠ Nema dodijeljenog osoblja": "⚠ No staff assigned",
  "⚠ Nedovoljno osoblja (nedostaje {count})": "⚠ Not enough staff (short {count})",
  "Plan ne sadrži startere ni bigu za odabrani datum.": "The plan has no starters or biga for the selected date.",
  "Nije moguće izračunati potrebe za starterom: {message}": "Cannot calculate starter requirements: {message}",
  "Parametri startera spremljeni.": "Starter parameters saved.",
  "Spremanje parametara nije uspjelo: {message}": "Saving parameters failed: {message}",
  "Nije moguće otvoriti prozor za ispis": "Could not open the print window",
  "1. NOĆNI STARTER": "1. NIGHT STARTER",
  "Priprema dan prije, ~12h | omjer 1 (matica) : {ratio} (brašno) uz {pct} hidratacije": "Prep the day before, ~12h | ratio 1 (mother) : {ratio} (flour) at {pct} hydration",
  "mikser": "mixer",
  "kg/zamjes": "kg/mix",
  "Ukupno [kg]": "Total [kg]",
  "Po zamjesu [kg]": "Per mix [kg]",
  "STARTER DNEVNI/MATICA": "DAILY STARTER / MOTHER",
  "MANITOBA BRAŠNO": "MANITOBA FLOUR",
  "VODA": "WATER",
  "UKUPNO NOĆNI": "NIGHT TOTAL",
  "Od toga za jutarnji starter {kg} kg": "Of which for morning starter {kg} kg",
  ", za raženi starter {kg} kg": ", for rye starter {kg} kg",
  "2. JUTARNJI STARTER": "2. MORNING STARTER",
  "Radni nalog {nalog} kg + sigurnosna {sig} kg | omjer 1 (noćni) : {ratio} (brašno) uz {pct} hidratacije": "Work order {nalog} kg + safety {sig} kg | ratio 1 (night) : {ratio} (flour) at {pct} hydration",
  "Zamjes [kg]": "Mix [kg]",
  "STARTER NOĆNI": "NIGHT STARTER",
  "UKUPNO JUTARNJI": "MORNING TOTAL",
  "3. RAŽENI STARTER": "3. RYE STARTER",
  "Omjer 1 (noćni) : {ratio} (raženo brašno) uz {pct} hidratacije": "Ratio 1 (night) : {ratio} (rye flour) at {pct} hydration",
  "RAŽENO BRAŠNO": "RYE FLOUR",
  "UKUPNO RAŽENI": "RYE TOTAL",
  "4. DNEVNI STARTER / MATICA": "4. DAILY STARTER / MOTHER",
  "Ostaje za idući dan | omjer 1 (jutarnji) : {ratio} (brašno) uz {pct} hidratacije": "Held for the next day | ratio 1 (morning) : {ratio} (flour) at {pct} hydration",
  "STARTER JUTRO": "MORNING STARTER",
  "UKUPNO DNEVNI/MATICA": "DAILY / MOTHER TOTAL",
  "5. BIGA PRIPREMA": "5. BIGA PREP",
  "Priprema dan prije | smrznuti kvasac 0.05%, voda 38.63%": "Prep the day before | frozen yeast 0.05%, water 38.63%",
  "Za 1 kg": "Per 1 kg",
  "SMRZNUTI KVASAC": "FROZEN YEAST",
  "UKUPNO BIGA": "BIGA TOTAL",
  "Priprema startera i bige - {date}": "Starter and biga prep - {date}",
  "PRIPREMA STARTERA I BIGE": "STARTER AND BIGA PREP",
  "Izdao (tehnolog)": "Issued by (technologist)",
  "Odgovorni za starter": "Responsible for starter",
  "Kontrola": "Check",
  "Generirano iz MES sustava. Sva odstupanja od naloga upisati u napomenu.": "Generated from the MES. Record any deviations from the order in the notes.",
  "Hidratacija (% na brašno)": "Hydration (% of flour)",
  "Timeline za {date}:": "Timeline for {date}:",
  "(Timeline mora biti potvrdjen za izracun startera)": "(Timeline must be confirmed to calculate starters)",
  "Nema timeline-a za {date}": "No timeline for {date}",
  "Plan za {date} ne sadrži startere ni bigu.": "The plan for {date} has no starters or biga.",
  "Ulazne količine": "Input quantities",
  "Starter iz radnog naloga (kg)": "Starter from work order (kg)",
  "Iz plana: {kg} kg": "From plan: {kg} kg",
  "Raženi starter iz radnog naloga (kg)": "Rye starter from work order (kg)",
  "Biga iz radnog naloga (kg)": "Biga from work order (kg)",
  "Sigurnosna količina (kg)": "Safety quantity (kg)",
  "Dodaje se na jutarnji starter": "Added onto the morning starter",
  "Dnevni starter / matica (kg)": "Daily starter / mother (kg)",
  "Ostaje za idući dan": "Held for the next day",
  "Mikser za noćni starter": "Mixer for night starter",
  "— odaberi mikser —": "— select mixer —",
  "Kapacitet {kg} kg po zamjesu (Baza → Strojevi)": "Capacity {kg} kg per mix (Master data → Machines)",
  "Mikser bez upisanog kapaciteta — računa se s {kg} kg": "Mixer has no capacity entered — using {kg} kg",
  "Preracunaj iz plana": "Recalculate from plan",
  "Sakrij parametre": "Hide parameters",
  "Parametri osvježavanja": "Refresh parameters",
  "Svaki stupanj je jedno osvježavanje: na 1 dio startera dolazi zadani dio brašna, a voda je postotak na to brašno. Vrijednosti se spremaju u MES postavke i vrijede za sve dane.": "Each stage is one refresh: for 1 part starter add the set part of flour, and water is a percentage of that flour. Values are saved in MES settings and apply to all days.",
  "Noćni starter": "Night starter",
  "Brašna na 1 dio matice": "Flour per 1 part mother",
  "Jutarnji starter": "Morning starter",
  "Brašna na 1 dio noćnog": "Flour per 1 part night starter",
  "Raženi starter": "Rye starter",
  "Raženog brašna na 1 dio noćnog": "Rye flour per 1 part night starter",
  "Dnevni starter / matica": "Daily starter / mother",
  "Brašna na 1 dio jutarnjeg": "Flour per 1 part morning starter",
  "Spremi parametre": "Save parameters",
  "Vrati zadane vrijednosti": "Reset to defaults",
  "1. Noćni starter — {kg} kg": "1. Night starter — {kg} kg",
  "{n} zamjesa": "{n} mixes",
  "2. Jutarnji starter — {kg} kg": "2. Morning starter — {kg} kg",
  "3. Raženi starter — {kg} kg": "3. Rye starter — {kg} kg",
  "4. Dnevni starter / matica — {kg} kg": "4. Daily starter / mother — {kg} kg",
  "Troši {starter} kg jutarnjeg startera — pokriveno sigurnosnom količinom od {sig} kg.": "Uses {starter} kg of morning starter — covered by the {sig} kg safety quantity.",
  "5. Biga priprema — {kg} kg": "5. Biga prep — {kg} kg",
  "Detalji potražnje po zamjesu": "Demand details by mix",
  "Pripremi za print": "Prepare for print",
  "Uređivanje rasporeda po mikseru": "Edit schedule by mixer",
  "Promijeni redoslijed ili masu, zatim klikni Primijeni izmjene za preračun vremena.": "Change order or mass, then click Apply changes to recalculate times.",
  "Red.": "Seq.",
  "Kraj peč.": "Bake end",
  "Primijeni izmjene": "Apply changes",
  "Izmjene redoslijeda (PRIORITET / NOĆ / CIKCAK)": "Order changes (PRIORITY / NIGHT / ZIGZAG)",
  "Ostavi prazno ako nema izmjena. Nakon dodavanja regeneriraj timeline.": "Leave empty if there are no changes. After adding, regenerate the timeline.",
  "Radnja": "Action",
  "Br. zamjesa": "No. of mixes",
  "SVE ili broj": "ALL or a number",
  "Pozicija": "Position",
  "Dodaj izmjenu": "Add change",
  "Obriši sve izmjene": "Delete all changes",
  "Nema zamjesa za uređivanje. Vrati se na korak „Proizvodi“.": "No mixes to edit. Go back to the “Products” step.",
  "Uređivanje rasporeda po proizvodu": "Edit schedule by product",
  "Po proizvodu prilagodi redoslijed i masu zamjesa; prikazane su sve procesne faze. Klikni „Primijeni izmjene“ za preračun vremena.": "Adjust mix order and mass per product; all process phases are shown. Click “Apply changes” to recalculate times.",
  "Procesni podaci spremljeni": "Process data saved",
  "Procesni parametri": "Process parameters",
  "Sirovine i lotovi": "Ingredients and lots",
  "Vrati spremljeno": "Revert to saved",
  "Spremi procesne podatke": "Save process data",
  "Greška pri dohvatu faznih materijala": "Error fetching phase materials",
  "Prijedlog nije uspio": "Suggestion failed",
  "Potvrđeno stavki: {count}": "Lines confirmed: {count}",
  "Potvrda nije uspjela": "Confirmation failed",
  "Učitavanje materijala…": "Loading materials…",
  "Nema definiranih materijala za ovu fazu.": "No materials defined for this phase.",
  "Dodatni materijali (nema zalihe)": "Extra materials (no stock)",
  "Nema zalihe": "No stock",
  "Predloži (FIFO)": "Suggest (FIFO)",
  "Dodatni materijali (prijedlog FIFO)": "Extra materials (FIFO suggestion)",
  "Trošak: {amount}": "Cost: {amount}",
  " — stanje {remaining}": " — balance {remaining}",
  "Prijedlog": "Suggestion",
  "Potvrdi utrošak": "Confirm consumption",
  "Odstupanja spremljena": "Deviations saved",
  "Greska pri spremanju odstupanja: {message}": "Error saving deviations: {message}",
  "Parametri azurirani": "Parameters updated",
  "Parametri spremljeni": "Parameters saved",
  "Greska pri spremanju: {message}": "Error saving: {message}",
  "Timeline:": "Timeline:",
  "Zamjesi": "Mixes",
  "Parametri": "Parameters",
  "Kompletno": "Complete",
  "Djelomicno": "Partial",
  "Nije uneseno": "Not entered",
  "Unesi": "Enter",
  "Nema zamjesa za odabrani datum.": "No mixes for the selected date.",
  "Pregled unesenih parametara": "Entered parameters overview",
  "Temp (°C)": "Temp (°C)",
  "pH starter": "Starter pH",
  "Skart %": "Scrap %",
  "PROCESNI PARAMETRI": "PROCESS PARAMETERS",
  "Odstupanja": "Deviations",
  "Ucitavanje recepta...": "Loading recipe...",
  "Nema recepta za ovaj zamjes.": "No recipe for this mix.",
  "Recept:": "Recipe:",
  "Planirana masa:": "Planned mass:",
  "Plan (kg)": "Plan (kg)",
  "Stvarno (kg)": "Actual (kg)",
  "Odst. (kg)": "Dev. (kg)",
  "Razlog...": "Reason...",
  "* Odstupanja veca od 5% su oznacena": "* Deviations greater than 5% are highlighted",
  "Spremi odstupanja": "Save deviations",
  "Greška pri učitavanju naloga proizvodnje: {message}": "Error loading production orders: {message}",
  "Greška pri učitavanju zamjesa: {message}": "Error loading mixes: {message}",
  "Odaberite proizvod": "Select a product",
  "Nalog {number} kreiran": "Order {number} created",
  "Nalog ažuriran": "Order updated",
  "{count} naloga · {qty} kom (ukupno)": "{count} orders · {qty} pcs (total)",
  "Pretraga (broj naloga / proizvod)": "Search (order number / product)",
  "npr. RN-2026…, naziv proizvoda…": "e.g. RN-2026…, product name…",
  "+ Novi nalog": "+ New order",
  "Nema naloga proizvodnje.": "No production orders.",
  "Broj naloga": "Order number",
  "Rok (Due date)": "Due date",
  "NOVI NALOG PROIZVODNJE": "NEW PRODUCTION ORDER",
  "NALOG PROIZVODNJE": "PRODUCTION ORDER",
  "Broj se dodjeljuje automatski (RN-godina-broj) ako ga ne upišete": "The number is assigned automatically (WO-year-number) if you leave it blank",
  "automatski": "automatic",
  "Pretraži proizvod…": "Search product…",
  "Količina za proizvodnju": "Quantity to produce",
  "Nalog proizvodnje nema vezu na pojedinu zamjesu, pa se prikazuju zamjesi istog proizvoda proizvedeni u ovom rasponu datuma. Proširite raspon ako je plan pomaknut.": "A production order is not linked to a single mix, so mixes of the same product in this date range are shown. Widen the range if the plan has moved.",
  "Od datuma": "From date",
  "Do datuma": "To date",
  "Učitavanje zamjesa…": "Loading mixes…",
  "Nema zamjesa ovog proizvoda u odabranom rasponu.": "No mixes of this product in the selected range.",
  "Uneseno": "Entered",
  "Kreiraj nalog": "Create order",
  "Spremi nalog": "Save order",
  "Kasni {min} min": "{min} min late",
  "Rani {min} min": "{min} min early",
  "Na vrijeme": "On time",
  "Zadatak spremljen": "Task saved",
  "Stvarno": "Actual",
  "predviđeno {start} – {end}": "planned {start} – {end}",
  "od {time}": "from {time}",
  "Vremena su predpopunjena planom; uredi po potrebi ili upiši trenutno vrijeme tipkama Početak/Kraj. Spremaju se tek klikom na „Spremi“. Odnose se na datum proizvodnje ({date}).": "Times are prefilled from the plan; edit as needed or stamp the current time with Start/End. They are saved only when you click “Save”. They refer to the production date ({date}).",
  "Početak = sad": "Start = now",
  "Kraj = sad": "End = now",
  "Izađi": "Exit",
  "Cijeli zaslon": "Full screen",
  "Nema potvrđene proizvodnje za {date}.": "No confirmed production for {date}.",
  "Nema timelinea za {date}.": "No timeline for {date}.",
  "Nema zadataka za ovaj odjel.": "No tasks for this department.",
  "Nema zamjesa za ispis za odabranu fazu.": "No mixes to print for the selected phase.",
  "Otvaranje ispisa blokirano. Dozvolite skočne prozore (pop-ups).": "Print window blocked. Allow pop-ups.",
  "Pocetak:": "Start:",
  "Kraj:": "End:",
  "Trajanje:": "Duration:",
  "Receptura je u apsolutnim kolicinama (g / kom / list). Prikaz mase po zamjesu za slasticarske recepture jos nije podrzan.": "The recipe is in absolute quantities (g / pc / sheet). Per-mix mass display is not yet supported for pastry recipes.",
  "Nema zamjesa za ovu fazu na {date}": "No mixes for this phase on {date}",
  "Poluproizvod": "Semi-finished",
  "LOT po zamjesu": "LOT by mix",
  "Šifra zamjesa": "Mix code",
  "Kg / zamjes": "Kg / mix",
  "UKUPNO": "TOTAL",
  "Zamjesa:": "Mixes:",
  "Plan:": "Plan:",
  "Receptura nije dostupna.": "Recipe is not available.",
  "Plan poč. / stv.": "Plan start / act.",
  "Plan kraj / stv.": "Plan end / act.",
  "Temp. tijesta (°C)": "Dough temp. (°C)",
  "Ukupno:": "Total:",
  "Vrijeme (min)": "Time (min)",
  "Odvaga (g)": "Scaling (g)",
  "RADNI NALOG": "WORK ORDER",
  "Broj zamjesa:": "Number of mixes:",
  "Generirano iz Poweriot MES sustava. Sva odstupanja od naloga upisati u napomenu.": "Generated from the Poweriot MES. Record any deviations from the order in the notes.",
  "Zavrseno": "Completed",
  "Preskoceno": "Skipped",
  "Auto-refresh (60s)": "Auto-refresh (60s)",
  "Osvjezi": "Refresh",
  "Ukupno zamjesa": "Total mixes",
  "Ceka na red": "Waiting",
  "Pauzirano / Otkazano": "On hold / Canceled",
  "Napredak proizvodnje": "Production progress",
  "{done} od {total} zamjesa zavrseno": "{done} of {total} mixes completed",
  "Usporedba plana i izvršenja": "Plan vs actual",
  "Stvarno ({count} zamjesa)": "Actual ({count} mixes)",
  "Uključite barem jedan sloj za prikaz.": "Turn on at least one layer to display.",
  "Napredak po proizvodu": "Progress by product",
  "{done}/{total} zamjesa": "{done}/{total} mixes",
  "{count} zavrseno": "{count} completed",
  "{count} u tijeku": "{count} in progress",
  "Promijeni status": "Change status",
  "Nema potvrdjenog timeline-a za {date}": "No confirmed timeline for {date}",
  "Odaberite drugi datum ili kreirajte timeline u sekciji Planiranje": "Choose another date or create a timeline in Planning",
  "Kreirajte i potvrdite plan u Planiranje sekciji.": "Create and confirm a plan in the Planning section.",
  "Nema podataka za {date}.": "No data for {date}.",
  "Mijesanje: {start} - {end}": "Mixing: {start} - {end}",
  "Pecenje: {start} - {end}": "Baking: {start} - {end}",
  "Mijesanje": "Mixing",
  "Pecenje": "Baking",
  "Kraj mij.": "Mix end",
  "Start pec.": "Bake start",
  "Nema podataka o strojevima za odabrani period.": "No machine data for the selected period.",
  "Efikasnost strojeva": "Machine efficiency",
  "Ukupno radi (min)": "Total running (min)",
  "Ukupno stoji (min)": "Total idle (min)",
  "Efikasnost (%)": "Efficiency (%)",
  "Propusnost (komadi/h)": "Throughput (pcs/h)",
  "Potrebni podaci o broju komada po zamjesu za izracun propusnosti.": "Piece counts per mix are needed to calculate throughput.",
  "Nema podataka o kvaliteti za odabrani period.": "No quality data for the selected period.",
  "Trend analiza": "Trend analysis",
  "Box plot / line chart za praćenje meta parametara kroz vrijeme": "Box plot / line chart for tracking dough parameters over time",
  "Korelacije meta parametara": "Dough parameter correlations",
  "Pearsonova korelacija - crveno = negativna, plavo = pozitivna": "Pearson correlation - red = negative, blue = positive",
  "Heatmap korelacija - placeholder": "Correlation heatmap - placeholder",
  "Troskovi sirovina, pakiranja i VPC po zamjesu. Cijene se uzimaju prema datumu proizvodnje.": "Ingredient, packaging and wholesale costs per mix. Prices are taken as of the production date.",
  "Ukupni trosak sirovina": "Total ingredient cost",
  "Ukupni trosak pakiranja": "Total packaging cost",
  "Ukupna VPC": "Total wholesale",
  "Ukupna marza": "Total margin",
  "Sirovine (EUR)": "Ingredients (EUR)",
  "Pakiranje (EUR)": "Packaging (EUR)",
  "VPC (EUR)": "Wholesale (EUR)",
  "Ukupni trosak": "Total cost",
  "Marza (EUR)": "Margin (EUR)",
  "Marza (%)": "Margin (%)",
  "Nema detaljnih podataka o troskovima za odabrani period.": "No detailed cost data for the selected period.",
  "Od datuma (trend)": "From date (trend)",
  "Do datuma (trend)": "To date (trend)",
  "Cijene & VPC": "Prices & wholesale",
  "Greška pri učitavanju izvještaja: {message}": "Error loading report: {message}",
  "Dnevni proizvodni izvještaj — {date}": "Daily production report — {date}",
  "Konačni plan:": "Final plan:",
  "Potvrđen:": "Confirmed:",
  "Nepotvrđen": "Unconfirmed",
  "Start rada:": "Work start:",
  "Verzija plana u bazi:": "Plan version in database:",
  "Promjene naloga:": "Order changes:",
  "prije starta": "before start",
  "real-time": "real-time",
  "Ispis / PDF": "Print / PDF",
  "Glavne proizvodne metrike (plan vs. ostvareno)": "Main production metrics (plan vs actual)",
  "Ključna metrika (KPI)": "Key metric (KPI)",
  "Odstupanje (razlika)": "Variance (difference)",
  "Broj zamjesa (šarži)": "Number of mixes (batches)",
  "Gotovi komadi (zapakirano)": "Finished pieces (packed)",
  "Evidentirani škart": "Recorded scrap",
  "0 kom (0,0 %)": "0 pcs (0.0 %)",
  "Yield (iskorištenje)": "Yield",
  "VPC vrijednost zapakirano": "Wholesale value packed",
  "Trošak primarnih sirovina": "Primary ingredient cost",
  "Trošak pakiranja": "Packaging cost",
  "— (priprema u bazi)": "— (pending in database)",
  "Trošak rada (osoblje)": "Labour cost (staff)",
  "Bruto marža": "Gross margin",
  "Razlika:": "Variance:",
  "Udio škarta": "Scrap share",
  "Plan: 0,0 %": "Plan: 0.0 %",
  "Marža / VPC zapakirano": "Margin / packed wholesale",
  "Rad / VPC proizvedeno": "Labour / produced wholesale",
  "Plan: —": "Plan: —",
  "Razlika: —": "Variance: —",
  "Strojevi — radni timeline (planirano vs. ostvareno)": "Machines — working timeline (planned vs actual)",
  "Nema unesenih satnica za prikaz timelinea na strojevima za ovaj datum.": "No times entered to show the machine timeline for this date.",
  "Detaljno sučeljavanje po proizvodu (plan vs. ostvareno)": "Detailed comparison by product (plan vs actual)",
  "Nema podataka za sučeljavanje po proizvodu.": "No data for product comparison.",
  "Šarži (Pl/Os)": "Batches (Pl/Ac)",
  "Komada (Pl/Os)": "Pieces (Pl/Ac)",
  "Odstupanje kom": "Piece variance",
  "Škart kom (%)": "Scrap pcs (%)",
  "Yield (%)": "Yield (%)",
  "Plan VPC": "Plan wholesale",
  "VPC zapakirano": "Packed wholesale",
  "Razlika VPC": "Wholesale variance",
  "Razlika troška": "Cost variance",
  "UKUPNO ZA DAN": "DAY TOTAL",
  "Operativni plan rasporeda na strojevima": "Operational machine schedule",
  "Nema planiranih zamjesa za ovaj datum.": "No planned mixes for this date.",
  "Šarža / MixCode": "Batch / MixCode",
  "Plan masa": "Plan mass",
  "Plan komada": "Plan pieces",
  "Trošak sirovina": "Ingredient cost",
  "Financijski plan (grupirano po proizvodu)": "Financial plan (grouped by product)",
  "Šarži": "Batches",
  "Masa": "Mass",
  "VPC/kom": "Wholesale/pc",
  "VPC ukupno": "Wholesale total",
  "Marža": "Margin",
  "[poluproizvod]": "[semi-finished]",
  "PLANIRANO UKUPNO ZA DAN": "PLANNED DAY TOTAL",
  "Poluproizvodi su informativni — njihov trošak je već uračunat u gotove proizvode kroz podrecepture, pa ne ulazi u dnevni zbroj.": "Semi-finished goods are informational — their cost is already included in finished goods via sub-recipes, so they are not added to the daily total.",
  "Financijsko ostvareno (grupirano po proizvodu)": "Financial actual (grouped by product)",
  "Nema evidentiranih ostvarenih šarži za ovaj datum. Upišite procesne podatke u sekciji Izvršavanje.": "No recorded actual batches for this date. Enter process data in Execution.",
  "Zapakirano": "Packed",
  "Škart (kom / %)": "Scrap (pcs / %)",
  "Stvarni trošak": "Actual cost",
  "Ostvareni VPC": "Realized wholesale",
  "OSTVARENO UKUPNO ZA DAN": "ACTUAL DAY TOTAL",
  "Ostvarene šarže": "Actual batches",
  "Škart": "Scrap",
  "Učitavanje izvještaja…": "Loading report…",
  "Nema izvještaja za {date}": "No report for {date}",
  "Odaberite datum s potvrđenim planom ili osvježite prikaz.": "Choose a date with a confirmed plan, or refresh the view.",
  "Marža / VPC zap.": "Margin / packed wholesale",
  "Rad / VPC proiz.": "Labour / produced wholesale",
  "Plan VPC (€)": "Plan wholesale (€)",
  "VPC zapakirano (€)": "Packed wholesale (€)",
  "Razlika VPC (€)": "Wholesale variance (€)",
  "Nema evidentiranih ostvarenih šarži za ovaj datum.": "No recorded actual batches for this date.",
  "Dnevni proizvodni izvještaj": "Daily production report",
  "Izvještaj generiran automatski iz MES baze {when}.": "Report generated automatically from the MES at {when}.",
  "Troškovi pakiranja i rada označeni su s \"—\" te će biti uključeni nakon unosa u bazu.": "Packaging and labour costs are marked \"—\" and will be included after they are entered in the database.",
  "Financijsko ostvareno (zabilježenih šarži: {count})": "Financial actual (recorded batches: {count})",
  "Timeline strojeva, planirano i ostvareno": "Machine timeline, planned and actual",
  "Greška pri dohvatu sirovina zamjesa": "Error fetching mix ingredients",
  "Količina mora biti veća od 0": "Quantity must be greater than 0",
  "Sirovina ažurirana": "Ingredient updated",
  "Izmjena nije uspjela": "Change failed",
  "Uklanjanje nije uspjelo": "Removal failed",
  "Potvrda poništena — stavka je ponovno uređiva": "Confirmation undone — the line is editable again",
  "Poništenje nije uspjelo": "Undo failed",
  "Nema stavki za predlaganje": "No lines to suggest",
  "Nedostaje zaliha: {items}": "Stock short: {items}",
  "Odaberite sirovinu": "Select an ingredient",
  "Odaberite lot": "Select a lot",
  "Unesite količinu": "Enter quantity",
  "Sirovina dodana": "Ingredient added",
  "Dodavanje nije uspjelo": "Add failed",
  "Spremite izmijenjene stavke prije potvrde": "Save changed lines before confirming",
  "Učitavanje sirovina…": "Loading ingredients…",
  "Nema recepture ni evidentiranih sirovina za ovu zamjesu.": "No recipe or recorded ingredients for this mix.",
  "Sirovine u zamjes": "Ingredients in mix",
  " · trošak {amount}": " · cost {amount}",
  "Recept (kg)": "Recipe (kg)",
  "Količina (kg)": "Quantity (kg)",
  "Napomena / razlog": "Note / reason",
  "izvan recepture": "outside recipe",
  "Poništi": "Undo",
  "poluproizvod": "semi-finished",
  "Pretraži sirovinu…": "Search ingredient…",
  "— odaberi lot —": "— select lot —",
  "Razlog zamjene (obavezno)": "Replacement reason (required)",
  "Razlog…": "Reason…",
  "Nespremljeno": "Unsaved",
  "Zamjena": "Replacement",
  "bez lota": "no lot",
  "Lot nije dodijeljen": "Lot not assigned",
  "Ne vodi se po lotu (voda / poluproizvod)": "Not lot-tracked (water / semi-finished)",
  "Info": "Info",
  "Razlog (obavezno izvan recepture)": "Reason (required outside recipe)",
  "Nova": "New",
  "Predloži lotove (FEFO)": "Suggest lots (FEFO)",
  "+ Dodaj sirovinu": "+ Add ingredient",
  "Potvrdi utrošak ({count})": "Confirm consumption ({count})",
  "Potvrda knjiži izdatak sa skladišta proizvodnje i zaključa stavku. Izmjena sirovine ili stavka izvan recepture zahtijevaju obrazloženje.": "Confirming posts an issue from the production warehouse and locks the line. Changing an ingredient or a line outside the recipe requires a reason.",
  "Plan vs. stvarno — {date}": "Plan vs actual — {date}",
  "↕️ Povuci zamjesu na drugu da zamijene mjesta unutar iste trake": "↕️ Drag a mix onto another to swap places in the same lane",
  "↕️ Promjena redoslijeda radi u pogledu po mikseru ili po peći": "↕️ Reordering works in the mixer or oven view",
  "Timeline Gantt — {from} – {to}": "Timeline Gantt — {from} – {to}",
  "Timeline Gantt - {date}": "Timeline Gantt - {date}",
  "Klikni na fazu da označiš njenu zamjesu u svim trakama, ponovni klik je odznačuje": "Click a phase to highlight its mix in all lanes; click again to clear",
  "Klikni na red da ga odabereš, ponovni klik ga odznačuje": "Click a row to select it; click again to clear",
  "{count} odabrano": "{count} selected",
  "Poništi odabir": "Clear selection",
  "Radnici": "Workers",
  "Teče paralelno s drugom fazom istog koraka": "Runs in parallel with another phase of the same step",
  "već na {count} sirovini/a": "already on {count} ingredient(s)",
  "Pretraži Ritam artikle...": "Search Ritam articles...",
  "Ukloni {name}": "Remove {name}",
  "Faze proizvodnje": "Production phases",
  "+ Dodaj fazu": "+ Add phase",
  "Nema definiranih faza. Koristit ce se zadane vrijednosti.": "No phases defined. Default values will be used.",
  "Faze se izvode redom odozgo prema dolje. Sa \"Spoji s gornjom\" dvije faze postaju jedna paralelna grupa — krecu i zavrsavaju istovremeno i dijele jedno trajanje, a stroj, radnici i temperatura ostaju po fazi.": "Phases run top to bottom. With “Merge with above”, two phases become one parallel group — they start and finish together and share one duration, while machine, workers and temperature stay per phase.",
  "Izvodenje": "Execution",
  "Trajanje (min)": "Duration (min)",
  "Temp (C)": "Temp (C)",
  "Gore": "Up",
  "Dolje": "Down",
  "Paralelno": "Parallel",
  "Slijedno": "Sequential",
  "Odaberi fazu": "Select phase",
  "Bez stroja": "No machine",
  "Izvodi ovu fazu istovremeno s grupom iznad": "Run this phase at the same time as the group above",
  "Spoji s gornjom": "Merge with above",
  "Izvadi fazu iz paralelne grupe": "Remove phase from parallel group",
  "Odvoji": "Split",
  "Greška pri učitavanju sirovina po fazi: {message}": "Error loading ingredients by phase: {message}",
  "Faza #{id}": "Phase #{id}",
  "Odaberite fazu": "Select a phase",
  "Odaberite materijal": "Select a material",
  "Sirovina dodana u fazu": "Ingredient added to phase",
  "Greška pri dodavanju: {message}": "Error adding: {message}",
  "Spremljeno": "Saved",
  "Uklonjeno": "Removed",
  "Greška pri brisanju: {message}": "Error deleting: {message}",
  "Dodatne sirovine po fazi (repro / ambalaža)": "Extra ingredients by phase (rework / packaging)",
  "Spremite proizvod prije dodavanja dodatnih sirovina.": "Save the product before adding extra ingredients.",
  "Osnova": "Basis",
  "Škart %": "Scrap %",
  "Nema definiranih dodatnih sirovina.": "No extra ingredients defined.",
  "Pretraži materijal...": "Search material...",
  "+ Dodaj": "+ Add",
  "Osnova količine određuje obračun: „po komadu\" množi s brojem komada šarže, „po šarži\" je fiksno, „po kg tijesta\" množi s masom zamjesa.": "Quantity basis drives the calculation: “per piece” multiplies by batch piece count, “per batch” is fixed, “per kg dough” multiplies by mix mass.",
  "mij": "mix",
  "Masa zamjesa:": "Mix mass:",
  "Komada/zamjes:": "Pieces/mix:",
  "Tezina komada:": "Piece weight:",
  "Mijesanje:": "Mixing:",
  "Fermentacija:": "Fermentation:",
  "Obrada:": "Processing:",
  "Zavrsno dizanje:": "Final proof:",
  "Pecenje:": "Baking:",
  "Temp. pecenja:": "Baking temp.:",
  "Aktivni recept:": "Active recipe:",
  "+ Dodaj u plan": "+ Add to plan",
  "Nedjelja": "Sunday",
  "Ponedjeljak": "Monday",
  "Utorak": "Tuesday",
  "Srijeda": "Wednesday",
  "Četvrtak": "Thursday",
  "Petak": "Friday",
  "Subota": "Saturday",
  "po komadu": "per piece",
  "po šarži": "per batch",
  "po kg tijesta": "per kg dough",
  "baker %": "baker %",
  "Miješač": "Mixer operator",
  "Operater stroja": "Machine operator",
  "Operater": "Operator",
  "Pečar": "Baker",
  "Pakirer": "Packer",
  "Zamjesi i procesni podaci": "Mixes and process data",
  "Sažetak": "Summary",
  "{n} zamjes": "{n} mix",
  "Biga": "Biga",
  "Starter": "Starter",

  // Database / Development / Quality / Labos / Batches / Tablet
  "Naziv poluproizvoda je obavezan": "Semi-finished product name is required",
  "Poluproizvod dodan": "Semi-finished product added",
  "Greška pri učitavanju: {message}": "Error loading: {message}",
  "Poluproizvod i recept spremljeni": "Semi-finished product and recipe saved",
  "Svi pogoni": "All plants",
  "+ Dodaj poluproizvod": "+ Add semi-finished product",
  "Starteri, enzimi i mješavine sjemena — svaki ima vlastiti recept od sirovina.": "Starters, enzymes and seed mixes — each has its own ingredient recipe.",
  "Pogon": "Plant",
  "Linija u receptu": "Recipe line",
  "{value} min": "{value} min",
  "{type} — recept": "{type} — recipe",
  "— nije odreden —": "— not set —",
  "Raspored proizvodnje": "Production schedule",
  "Kada se ovaj poluproizvod radi u odnosu na gotov proizvod koji ga koristi.": "When this semi-finished product is made relative to the finished product that uses it.",
  "Pravilo": "Rule",
  "Isti dan": "Same day",
  "Dan(a) prije": "Day(s) before",
  "Određeni dan u tjednu": "Specific weekday",
  "Broj dana prije": "Days before",
  "Dan u tjednu": "Weekday",
  "Recept (sirovine)": "Recipe (ingredients)",
  "Kolicina": "Quantity",
  "-- Odaberi --": "-- Select --",
  "Spremi recept": "Save recipe",
  "Novi poluproizvod": "New semi-finished product",
  "Naziv *": "Name *",
  "npr. Raženi starter": "e.g. Rye starter",
  "Tip *": "Type *",
  "Recept (sastav) poluproizvoda uređuje se nakon dodavanja.": "The semi-finished product recipe (composition) is edited after adding.",
  "Spremam…": "Saving…",
  "Greska pri ucitavanju recepata: {message}": "Error loading recipes: {message}",
  "Kolicine": "Quantities",
  "Poluproizvod #{id}": "Semi-finished #{id}",
  "Greska pri ucitavanju recepta: {message}": "Error loading recipe: {message}",
  "Recepturni parametri spremljeni": "Recipe parameters saved",
  "Greska pri spremanju parametara: {message}": "Error saving parameters: {message}",
  "Sve linije moraju imati količinu veću od nule i jedinicu": "Every line must have a quantity greater than zero and a unit",
  "Postotak brasna mora biti 100% (±0.5%)": "Flour percentage must be 100% (±0.5%)",
  "Sve linije moraju biti ispravno odabrane": "Every line must be selected correctly",
  "Recept spremljen kao nova verzija v{version}": "Recipe saved as new version v{version}",
  "Recept spremljen kao nova verzija": "Recipe saved as a new version",
  "Množitelj": "Multiplier",
  "Osnovna": "Base",
  "Množitelji se postavljaju na recepturi (npr. 5, 7.5, 10).": "Multipliers are set on the recipe (e.g. 5, 7.5, 10).",
  "Broj linija": "Line count",
  "Ukupno ({unit})": "Total ({unit})",
  "Ukupno PEK": "Total baker's %",
  "Brasno PEK": "Flour baker's %",
  "Mora biti 100%": "Must be 100%",
  "Hidracija faza 1": "Hydration phase 1",
  "Ukupna hidracija": "Total hydration",
  "Status verzije": "Version status",
  "Aktivna verzija": "Active version",
  "Arhivirana verzija": "Archived version",
  "Biljeske:": "Notes:",
  "Ucitavanje sastojaka...": "Loading ingredients...",
  "Kolicina {factor}": "Quantity {factor}",
  "Pekarski %": "Baker's %",
  "Recept nema definiranih sastojaka.": "This recipe has no ingredients defined.",
  "Recept jos nema unesene parametre.": "This recipe has no parameters entered yet.",
  "Napomena: Parametri se spremaju na ovu verziju recepta i ne stvaraju novu verziju. Prazna polja ostaju neunesena. Nova verzija recepta preuzima zadnje spremljene parametre.": "Note: Parameters are saved on this recipe version and do not create a new version. Empty fields stay unset. A new recipe version inherits the last saved parameters.",
  "Slasticarna: kolicine u gramima, komadima ili listovima.": "Pastry: quantities in grams, pieces or sheets.",
  "Pekara: pekarski postotak brasna (PEK %).": "Bakery: baker's percentage of flour (PEK %).",
  "Mnozitelji": "Multipliers",
  "npr. 5, 7.5, 10": "e.g. 5, 7.5, 10",
  "Razine na koje se ova receptura skalira.": "Levels this recipe is scaled to.",
  "Napomena: Spremanje ce stvoriti novu verziju recepta. Stara verzija ostaje sacuvana.": "Note: Saving will create a new recipe version. The old version remains stored.",
  "Svi proizvodi": "All products",
  "Prikazi starije verzije": "Show older versions",
  "Nema recepata za odabrani filter.": "No recipes for the selected filter.",
  "Naziv recepta": "Recipe name",
  "Broj sastojaka": "Ingredient count",
  "Ukupno %": "Total %",
  "Arhivirana": "Archived",
  "Uredivanje recepta": "Edit recipe",
  "Uredivanje recepturnih parametara": "Edit recipe parameters",
  "Detalji recepta": "Recipe details",
  "Spremi novu verziju": "Save new version",
  "Uredi parametre": "Edit parameters",
  "Uredi recept": "Edit recipe",
  "Naziv sastojka je obavezan": "Ingredient name is required",
  "Sastojak uspjesno dodan": "Ingredient added successfully",
  "Greska pri dodavanju sastojka: {message}": "Error adding ingredient: {message}",
  "Ritam artikli spremljeni": "Ritam articles saved",
  "Greska pri spremanju artikala: {message}": "Error saving articles: {message}",
  "+ Dodaj sastojak": "+ Add ingredient",
  "Nema sastojaka u sustavu.": "No ingredients in the system.",
  "Sifra": "Code",
  "Ritam artikli": "Ritam articles",
  "Trenutna cijena": "Current price",
  "Nije povezano": "Not linked",
  "Detalji sastojka": "Ingredient details",
  "Isti Ritam artikl moze stajati na vise sirovina.": "The same Ritam article can be linked to multiple ingredients.",
  "Spremi artikle": "Save articles",
  "Povijest cijena": "Price history",
  "Cijena": "Price",
  "Nema povijesti cijena.": "No price history.",
  "NOVI SASTOJAK": "NEW INGREDIENT",
  "Dodavanje nove sirovine": "Add a new ingredient",
  "Naziv sastojka *": "Ingredient name *",
  "Naziv sastojka": "Ingredient name",
  "Tip sastojka": "Ingredient type",
  "Odaberi tip": "Select type",
  "Jedinica mjere": "Unit of measure",
  "Odaberi jedinicu": "Select unit",
  "Sifra sastojka": "Ingredient code",
  "Artikl iz Ritma koji se knjizi na ovu sirovinu. Moze ih biti vise, a isti artikl smije stajati i na drugoj sirovini.": "Ritam article posted to this ingredient. There can be several, and the same article may also sit on another ingredient.",
  "Kvarljiva roba": "Perishable goods",
  "Aktivan sastojak": "Active ingredient",
  "Naziv stroja je obavezan": "Machine name is required",
  "Tip stroja je obavezan": "Machine type is required",
  "Stroj uspjesno dodan": "Machine added successfully",
  "Stroj uspjesno azuriran": "Machine updated successfully",
  "Stroj za obradu": "Processing machine",
  "Komora za dizanje": "Proofing chamber",
  "Tip stroja:": "Machine type:",
  "Svi tipovi": "All types",
  "+ Dodaj stroj": "+ Add machine",
  "Nema strojeva u sustavu.": "No machines in the system.",
  "Dodaj stroj": "Add machine",
  "Uredi stroj": "Edit machine",
  "Naziv stroja *": "Machine name *",
  "npr. Mikser 1": "e.g. Mixer 1",
  "Tip stroja *": "Machine type *",
  "Kapacitet (kg)": "Capacity (kg)",
  "npr. 100": "e.g. 100",
  "Povezani uređaj (opcionalno)": "Linked device (optional)",
  "— nije povezano —": "— not linked —",
  "Aktivan stroj": "Active machine",
  "Tip:": "Type:",
  "Kapacitet:": "Capacity:",
  "Uređaj:": "Device:",
  "Greska pri ucitavanju faza: {message}": "Error loading phases: {message}",
  "Naziv proizvoda je obavezan": "Product name is required",
  "Proizvod uspjesno dodan": "Product added successfully",
  "Proizvod uspjesno azuriran": "Product updated successfully",
  "Odaberite barem jedan stroj za dodjelu.": "Select at least one machine to assign.",
  "Strojevi dodijeljeni za {ok} proizvoda.": "Machines assigned for {ok} products.",
  "Ažurirano {ok}, neuspješno {failed}.": "Updated {ok}, failed {failed}.",
  "Kod": "Code",
  "Mijesanje (min)": "Mixing (min)",
  "Fermentacija (min)": "Fermentation (min)",
  "Pecenje (min)": "Baking (min)",
  "Pretraži proizvode (naziv ili kod)…": "Search products (name or code)…",
  "Prikazi neaktivne proizvode": "Show inactive products",
  "+ Dodaj proizvod": "+ Add product",
  "Dodijeli strojeve": "Assign machines",
  "Odaberi sve": "Select all",
  "Nema proizvoda": "No products",
  "NOVI PROIZVOD": "NEW PRODUCT",
  "UREDI PROIZVOD": "EDIT PRODUCT",
  "Dodavanje novog proizvoda": "Add a new product",
  "Naziv proizvoda": "Product name",
  "Sifra proizvoda": "Product code",
  "Standardna masa zamjesa (kg)": "Standard mix mass (kg)",
  "Aktivan proizvod": "Active product",
  "Sakrij u sljedivosti": "Hide in traceability",
  "Otvori recept ovog proizvoda": "Open this product's recipe",
  "Ucitavanje faza...": "Loading phases...",
  "Status azuriran": "Status updated",
  "Greska: {message}": "Error: {message}",
  "Jeste li sigurni da zelite ukloniti ovu probu iz plana?": "Are you sure you want to remove this trial from the plan?",
  "Proba uklonjena iz plana": "Trial removed from the plan",
  "Ova proba je vec dodana za taj dan": "This trial is already added for that day",
  "Funkcionalnost dodavanja u plan - potreban backend endpoint": "Add-to-plan needs a backend endpoint",
  "Nije moguce otvoriti prozor za ispis": "Unable to open the print window",
  "Greska pri ispisu: {message}": "Print error: {message}",
  "Nema proba za ispis tog dana": "No trials to print for that day",
  "Draft probe ({count})": "Draft trials ({count})",
  "Draft probe - jos nisu izvedene. Mogu se rasporediti u plan i ispisati nalog.": "Draft trials — not yet executed. They can be scheduled and printed as work orders.",
  "◀ Prethodni": "◀ Previous",
  "Sljedeci ▶": "Next ▶",
  "Tjedan: {from} - {to}": "Week: {from} - {to}",
  "{count} proba": "{count} trials",
  "Ispisi sve naloge za ovaj dan": "Print all work orders for this day",
  "Ispisi sve ({count})": "Print all ({count})",
  "Nema planiranih proba.": "No scheduled trials.",
  "Gotovo": "Done",
  "Dodaj probu...": "Add trial...",
  "Greska pri ucitavanju detalja: {message}": "Error loading details: {message}",
  "Greska pri ucitavanju usporedbe: {message}": "Error loading comparison: {message}",
  "Potvrdjeno": "Confirmed",
  "Promovirano": "Promoted",
  "Arhivirano": "Archived",
  "Pokus oznacen kao zavrsen": "Trial marked as completed",
  "Unesite kod recepta": "Enter a recipe code",
  "Pokus promoviran u recept!": "Trial promoted to a recipe!",
  "Greska pri promociji: {message}": "Error promoting: {message}",
  "Nije moguce otvoriti prozor za ispis — provjerite blokadu popupa": "Unable to open the print window — check popup blocking",
  "← Spremljene probe": "← Saved trials",
  "Usporedi": "Compare",
  "Izvedba": "Execution",
  "Ocjena": "Score",
  "Svrha:": "Purpose:",
  "NOVA": "NEW",
  "Nema definiranih sastojaka.": "No ingredients defined.",
  "🖨️ Ispis radnog naloga": "🖨️ Print work order",
  "✓ Parametri vec uneseni ({date})": "✓ Parameters already entered ({date})",
  "Vrsta fermentacije": "Fermentation type",
  "Dnevna": "Day",
  "Nocna": "Night",
  "Temperatura (°C)": "Temperature (°C)",
  "Start mijesanja": "Mixing start",
  "Kraj mijesanja": "Mixing end",
  "Visina 1 (mjerica)": "Height 1 (gauge)",
  "Visina 2 (rheon)": "Height 2 (rheon)",
  "Start pecenja": "Baking start",
  "Kraj pecenja": "Baking end",
  "Temperatura pecenja (°C)": "Baking temperature (°C)",
  "Skart (kom)": "Scrap (pcs)",
  "Skart boja (kom)": "Colour scrap (pcs)",
  "Skart oblik (kom)": "Shape scrap (pcs)",
  "Dodatne napomene...": "Additional notes...",
  "Usporedi s pokusom": "Compare with trial",
  "Odaberi pokus za usporedbu": "Select a trial to compare",
  "Usporedba parametara": "Parameter comparison",
  "Usporedba recepture": "Recipe comparison",
  "Nema drugih pokusa za isti proizvod za usporedbu.": "No other trials for the same product to compare.",
  "Trenutni status:": "Current status:",
  "Pokus je u nacrtu. Mozete ga oznaciti kao zavrsen nakon sto unesete parametre.": "The trial is a draft. You can mark it completed after entering parameters.",
  "✓ Oznaci kao zavrseno": "✓ Mark as completed",
  "Pokus je zavrsen. Mozete ga promovirati u produkcijski recept.": "The trial is completed. You can promote it to a production recipe.",
  "Kod novog recepta": "New recipe code",
  "npr. REC-001": "e.g. REC-001",
  "🚀 Promoviraj u produkciju": "🚀 Promote to production",
  "✓ Ovaj pokus je vec promoviran u produkcijski recept.": "✓ This trial has already been promoted to a production recipe.",
  "Biljeske": "Notes",
  "Proba nije pronadena.": "Trial not found.",
  "Natrag na listu": "Back to list",
  "Parametri spremljeni!": "Parameters saved!",
  "Opazanje dodano": "Observation added",
  "PROBA - Tablet": "TRIAL - Tablet",
  "Odaberite probu za izvrsenje": "Select a trial to execute",
  "Nema potvrdenih proba za izvrsenje": "No confirmed trials to execute",
  "Masa:": "Mass:",
  "← Nazad": "← Back",
  "Hidracija faza 1:": "Hydration phase 1:",
  "Ukupna hidracija:": "Total hydration:",
  "%": "%",
  "NOVO": "NEW",
  "Sad": "Now",
  "Kraj mase": "Bulk fermentation end",
  "Pocetak zavrsne": "Final proof start",
  "Kraj zavrsne": "Final proof end",
  "Spec. vol (L/kg)": "Spec. vol (L/kg)",
  "Spremi parametri": "Save parameters",
  "Opazanja": "Observations",
  "Hladenje": "Cooling",
  "Unesite opazanje...": "Enter an observation...",
  "Nema opazanja": "No observations",
  "Greska pri ucitavanju pokusa: {message}": "Error loading trials: {message}",
  "+ Nova proba": "+ New trial",
  "Od datuma:": "From date:",
  "Do datuma:": "To date:",
  "Nema pokusa za odabrani filter.": "No trials for the selected filter.",
  "Svrha": "Purpose",
  "Otvori": "Open",
  "Unesite naziv pokusa i proizvod": "Enter the trial name and product",
  "Unesite svrhu pokusa (obavezno)": "Enter the trial purpose (required)",
  "Dodajte barem jedan sastojak": "Add at least one ingredient",
  "Ukupno brašno mora biti 100% prije spremanja — trenutno {pct}%": "Total flour must be 100% before saving — currently {pct}%",
  "Pokus uspjesno kreiran": "Trial created successfully",
  "Greska pri kreiranju: {message}": "Error creating: {message}",
  "Odaberite način kreiranja": "Choose a creation mode",
  "Način određuje s kojom recepturom počinjete — kasnije ju u svakom slučaju možete mijenjati.": "The mode sets which recipe you start from — you can still change it later.",
  "Način kreiranja probe": "Trial creation mode",
  "Odaberite izvorni recept": "Select the source recipe",
  "-- Prvo odaberite proizvod --": "-- Select a product first --",
  "-- Nema recepata za proizvod --": "-- No recipes for this product --",
  "Nastavi →": "Continue →",
  "Odaberite izvornu probu": "Select the source trial",
  "Proba": "Trial",
  "-- Nema spremljenih proba --": "-- No saved trials --",
  "bez svrhe": "no purpose",
  "Naziv pokusa *": "Trial name *",
  "npr. Test novog brasna": "e.g. New flour test",
  "Datum pokusa": "Trial date",
  "-- Odaberi ili unesi naziv --": "-- Select or enter a name --",
  "Ili novi naziv proizvoda": "Or a new product name",
  "Novi proizvod...": "New product...",
  "npr. 50": "e.g. 50",
  "Svrha *": "Purpose *",
  "Svrha pokusa...": "Trial purpose...",
  "Ukupni PEK": "Total baker's %",
  "Ukupno brašno (=100%)": "Total flour (=100%)",
  "Hidracija 1": "Hydration 1",
  "Hidracija 2": "Hydration 2",
  "Δ vrijednosti prikazuju promjenu naspram izvornog izvora ({label}).": "Δ values show the change versus the source ({label}).",
  "⚠️ Ukupno brašno mora biti 100% (trenutno {pct}%) prije skaliranja i spremanja.": "⚠️ Total flour must be 100% (currently {pct}%) before scaling and saving.",
  "kg zamjes": "kg mix",
  "Nova?": "New?",
  "Naziv nove sirovine...": "New ingredient name...",
  "{name} (izvorno)": "{name} (original)",
  "Tip...": "Type...",
  "Dodatne biljeske...": "Additional notes...",
  "Korak 1: Odaberite nacin kreiranja": "Step 1: Choose creation mode",
  "Korak 2: Definirajte pokus": "Step 2: Define the trial",
  "Stvori pokus": "Create trial",
  "Pokus {id}": "Trial {id}",
  "⚠️ NOVA": "⚠️ NEW",
  "Radni nalog probe - {code}": "Trial work order - {code}",
  "Pracenje - Mikser": "Tracking - Mixer",
  "Batch ID": "Batch ID",
  "Start": "Start",
  "pH start.": "pH starter",
  "pH zamj.": "pH mix",
  "pH Rheon": "pH Rheon",
  "Pracenje - Fermentacija": "Tracking - Fermentation",
  "Pracenje - Pecenje": "Tracking - Baking",
  "Vis. mjerica": "Height gauge",
  "Pracenje - Kvaliteta": "Tracking - Quality",
  "Skart boja": "Colour scrap",
  "Skart oblik": "Shape scrap",
  "Radni nalozi - {date}": "Work orders - {date}",
  "Pokus finaliziran": "Trial finalized",
  "Pokusi": "Trials",
  "Nema pokusa.": "No trials.",
  "Kreiraj prvu probu": "Create the first trial",
  "Nije ocijenjeno": "Not scored",
  "Unesite konacnu ocjenu (1-10):": "Enter the final score (1-10):",
  "Ocjena mora biti izmedju 1 i 10": "Score must be between 1 and 10",
  "Finaliziraj": "Finalize",
  "Unesite broj lota i dobavljaca": "Enter the lot number and supplier",
  "Lot uspjesno dodan": "Lot added successfully",
  "Greska pri dodavanju lota: {message}": "Error adding lot: {message}",
  "Jeste li sigurni da zelite deaktivirati lot {lot}?": "Are you sure you want to deactivate lot {lot}?",
  "Lot deaktiviran": "Lot deactivated",
  "Odaberite lot brasna": "Select a flour lot",
  "Analiza uspjesno dodana": "Analysis added successfully",
  "Prikazi neaktivne": "Show inactive",
  "+ Novi lot": "+ New lot",
  "Nema lotova brasna u sustavu.": "No flour lots in the system.",
  "Lot broj": "Lot number",
  "Dobavljac": "Supplier",
  "Tip brasna": "Flour type",
  "Kolicina (kg)": "Quantity (kg)",
  "+ Nova analiza": "+ New analysis",
  "Nema analiza u sustavu.": "No analyses in the system.",
  "Vlaga %": "Moisture %",
  "Proteini %": "Protein %",
  "Gluten %": "Gluten %",
  "Broj pad.": "Falling no.",
  "W": "W",
  "P/L": "P/L",
  "Lot detalji": "Lot details",
  "Analize brasna": "Flour analyses",
  "Lotovi": "Lots",
  "Analize": "Analyses",
  "LOT:": "LOT:",
  "Detalji lota brasna": "Flour lot details",
  "Dobavljac:": "Supplier:",
  "Tip brasna:": "Flour type:",
  "Kolicina:": "Quantity:",
  "Preostalo:": "Remaining:",
  "Datum prijema:": "Arrival date:",
  "Analiza od {date}": "Analysis of {date}",
  "Vlaga": "Moisture",
  "Proteini": "Protein",
  "Pepeo": "Ash",
  "Mokri gluten": "Wet gluten",
  "Gluten index": "Gluten index",
  "Broj padanja": "Falling number",
  "W vrijednost": "W value",
  "P/L omjer": "P/L ratio",
  "Farinogram": "Farinogram",
  "Apsorpcija vode": "Water absorption",
  "Vrijeme razvoja": "Development time",
  "Stabilnost": "Stability",
  "Omleksavanje": "Softening",
  "Broj kvalitete": "Quality number",
  "Ekstenzogram": "Extensogram",
  "Vrijeme": "Time",
  "Otpor (BU)": "Resistance (BU)",
  "Rastezljivost (mm)": "Extensibility (mm)",
  "R/E": "R/E",
  "Energija (cm²)": "Energy (cm²)",
  "Nema analiza za ovaj lot.": "No analyses for this lot.",
  "NOVI LOT": "NEW LOT",
  "Dodavanje novog lota brasna": "Add a new flour lot",
  "Broj lota *": "Lot number *",
  "npr. LOT-2024-001": "e.g. LOT-2024-001",
  "Dobavljac *": "Supplier *",
  "Naziv dobavljaca": "Supplier name",
  "npr. T-550": "e.g. T-550",
  "npr. 25000": "e.g. 25000",
  "Spremi lot": "Save lot",
  "NOVA ANALIZA": "NEW ANALYSIS",
  "Unos rezultata analize brasna": "Enter flour analysis results",
  "Lot brasna *": "Flour lot *",
  "Odaberi lot": "Select lot",
  "Datum analize": "Analysis date",
  "Naziv laboratorija": "Laboratory name",
  "URL certifikata": "Certificate URL",
  "https://...": "https://...",
  "Osnovni parametri": "Basic parameters",
  "Vlaga (%)": "Moisture (%)",
  "14.5": "14.5",
  "Proteini (%)": "Protein (%)",
  "12.0": "12.0",
  "Pepeo (%)": "Ash (%)",
  "0.55": "0.55",
  "Mokri gluten (%)": "Wet gluten (%)",
  "28.0": "28.0",
  "85": "85",
  "Broj padanja (s)": "Falling number (s)",
  "280": "280",
  "180": "180",
  "0.8": "0.8",
  "Apsorpcija vode (%)": "Water absorption (%)",
  "58.5": "58.5",
  "Vrijeme razvoja (min)": "Development time (min)",
  "3.5": "3.5",
  "Stabilnost (min)": "Stability (min)",
  "8.0": "8.0",
  "Omeksavanje (FU)": "Softening (FU)",
  "60": "60",
  "75": "75",
  "Grupa kvalitete (1-4)": "Quality group (1-4)",
  "2": "2",
  "Mjerenja u 3 vremenske tocke: 45', 90', 135'": "Measurements at 3 time points: 45', 90', 135'",
  "45 minuta": "45 minutes",
  "320": "320",
  "145": "145",
  "Omjer (R/E)": "Ratio (R/E)",
  "2.2": "2.2",
  "90 minuta": "90 minutes",
  "380": "380",
  "140": "140",
  "2.7": "2.7",
  "95": "95",
  "135 minuta": "135 minutes",
  "420": "420",
  "135": "135",
  "3.1": "3.1",
  "100": "100",
  "Spremi analizu": "Save analysis",
  "Odbijen": "Rejected",
  "Nema testa": "No test",
  "Valjano": "Valid",
  "Nepregledano": "Unchecked",
  "Greška pri učitavanju reda čekanja": "Error loading the queue",
  "Stavka odobrena — puštena iz karantene u zalihu.": "Item approved — released from quarantine into stock.",
  "Odobravanje nije uspjelo: {message}": "Approval failed: {message}",
  "{count} stavki odobreno — puštene iz karantene u zalihu.": "{count} items approved — released from quarantine into stock.",
  "{count} stavki nije odobreno.": "{count} items were not approved.",
  "Odobravanje…": "Approving…",
  "Odobri": "Approve",
  "Analiza": "Analysis",
  "Red čekanja — karantena": "Queue — quarantine",
  "Artikli u karanteni nakon primke. Kliknite": "Items in quarantine after goods receipt. Click",
  "za ručno puštanje stavke u zalihu, ili označite više stavki i odobrite ih odjednom.": "to release the item into stock manually, or select several items and approve them at once.",
  "Za brašno dodatno otvorite": "For flour also open",
  "Analizu": "Analysis",
  "za pregled blend-a, mjerenja i QC odluku.": "to review the blend, measurements and QC decision.",
  "Brašno": "Flour",
  "Ostali artikli": "Other articles",
  "Odobri odabrano ({count})": "Approve selected ({count})",
  "{message} — provjerite je li Hive pokrenut.": "{message} — check whether Hive is running.",
  "Nema brašna u karanteni.": "No flour in quarantine.",
  "Nema ostalih artikala u karanteni.": "No other articles in quarantine.",
  "kg": "kg",
  "Farinograf": "Farinograph",
  "Extensograf": "Extensograph",
  "Amylograf": "Amylograph",
  "Povijest testiranih LOT-ova": "History of tested LOTs",
  "Brašno koje je prošlo QC (pušteno ili odbijeno). Kliknite analizu za pregled svih mjerenja i blend-a.": "Flour that has passed QC (released or rejected). Click analysis to review all measurements and the blend.",
  "Svi ishodi": "All outcomes",
  "Pušteni": "Released",
  "Odbijeni": "Rejected",
  "Nema zapisa.": "No records.",
  "QC datum": "QC date",
  "F / E / A": "F / E / A",
  "Greška pri učitavanju analize": "Error loading analysis",
  "Puštate LOT u zalihu (released)?": "Release this LOT into stock?",
  "LOT pušten": "LOT released",
  "Odbijate LOT?": "Reject this LOT?",
  "LOT odbijen": "LOT rejected",
  "Učitavanje analize…": "Loading analysis…",
  "Analiza nije dostupna.": "Analysis is not available.",
  "Blend": "Blend",
  "Zahtijevaj valjano mjerenje pri puštanju": "Require a valid measurement on release",
  "Napomena QC (opcionalno)": "QC note (optional)",
  "Odbij": "Reject",
  "{count} mjerenja": "{count} measurements",
  "Zadnje: {when}": "Latest: {when}",
  "Ukratko": "Summary",
  "Ukupno testova na blendu:": "Total tests on the blend:",
  "Pregledajte pojedinačne uređaje ili karticu „Svi testovi” za kronološki popis.": "Review individual devices or the “All tests” tab for a chronological list.",
  "Sastav blend-a": "Blend composition",
  "Udio %": "Share %",
  "kg primljeno": "kg received",
  "Svi testovi na ovom blendu": "All tests on this blend",
  "Nema uvezenih testova.": "No imported tests.",
  "Uređaj": "Device",
  "ID": "ID",
  "Uzorak": "Sample",
  "Točaka": "Points",
  "Datoteka": "File",
  "da": "yes",
  "ne": "no",
  "Povijest QC odluka": "QC decision history",
  "Još nema zabilježenih odluka za ovaj LOT.": "No decisions recorded for this LOT yet.",
  "Pušteno": "Released",
  "Odbijeno": "Rejected",
  "Kvaliteta brašna": "Flour quality",
  "← Red čekanja": "← Queue",
  "Nema točaka mjerenja za ovaj zapis.": "No measurement points for this record.",
  "t (min)": "t (min)",
  "Prosjek": "Average",
  "Kod točke": "Point code",
  "Tekst": "Text",
  "Opis": "Description",
  "Još nema uvezenih mjerenja za ovaj blend.": "No imported measurements for this blend yet.",
  "valjano": "valid",
  "nevaljano": "invalid",
  "n/p": "n/a",
  "Uzorak: {name}": "Sample: {name}",
  "Masa: {value} g": "Mass: {value} g",
  "{count} točaka": "{count} points",
  "Metoda": "Method",
  "Operator": "Operator",
  "Uređaj SN": "Device SN",
  "Nema skaliranih sastojaka": "No scaled ingredients",
  "Unesite naziv uzorka": "Enter a sample name",
  "Nalog {code} kreiran": "Order {code} created",
  "Status ažuriran": "Status updated",
  "MES - Labos nalozi": "MES - Lab orders",
  "Plan naloga": "Order plan",
  "Razdoblje": "Period",
  "Zadnjih {d} dana": "Last {d} days",
  "Nema naloga za filter.": "No orders for this filter.",
  "Target brašno:": "Target flour:",
  "Pokreni": "Start",
  "Završi": "Finish",
  "Datum mjerenja": "Measurement date",
  "Target masa brašna: {value} g": "Target flour mass: {value} g",
  "Uključuju se samo brašno-sastojci (uklj. brašno iz startera i poluproizvoda). Voda je fiksno {ml} mL, umanjeno za vodu iz startera.": "Only flour ingredients are included (incl. flour from starters and semi-finished). Water is fixed at {ml} mL, reduced by starter water.",
  "Dodaje se 2% soli na masu brašna ({grams} g).": "2% salt is added on flour mass ({grams} g).",
  "QC uzorci brašna imaju prioritet. Količina vode ovisi o odabranoj metodi mjerenja.": "Flour QC samples have priority. Water quantity depends on the selected measurement method.",
  "Iz probe": "From trial",
  "Iz nule": "From scratch",
  "— odaberi —": "— select —",
  "+ Sirovina": "+ Ingredient",
  "Ukloni zadnju": "Remove last",
  "Naziv uzorka": "Sample name",
  "Receptura skalirana ({grams} g brašna)": "Recipe scaled ({grams} g flour)",
  "Ukupna masa zamjesa: {value} g": "Total mix mass: {value} g",
  "Voda: {ml} mL − {starter} g (starter) =": "Water: {ml} mL − {starter} g (starter) =",
  "{ml} mL za ručno dodati": "{ml} mL to add by hand",
  "Dodana sol:": "Added salt:",
  "(2% brašna)": "(2% of flour)",
  "Voda se dodaje prema metodi mjerenja (definira operater na uređaju).": "Water is added according to the measurement method (set by the operator on the device).",
  "Greška pri učitavanju mjerenja": "Error loading measurements",
  "Odaberite probu": "Select a trial",
  "Veza kreirana": "Link created",
  "Veza uklonjena": "Link removed",
  "Težina uzorka: {value} g": "Sample weight: {value} g",
  "Apsorpcija vode: {value} %": "Water absorption: {value} %",
  "Vlaga: {value} %": "Moisture: {value} %",
  "Težina: {value} g": "Weight: {value} g",
  "MES - Labos mjerenja": "MES - Lab measurements",
  "Pregled mjerenja s uređaja (pipeline). Ručno povežite mjerenje s probom.": "Device measurement overview (pipeline). Link a measurement to a trial manually.",
  "Prikaži i nevalidna": "Show invalid too",
  "Pretraži uzorak": "Search sample",
  "npr. T550": "e.g. T550",
  "{count} mjerenja — {device}": "{count} measurements — {device}",
  "Nema mjerenja za odabrane filtere.": "No measurements for the selected filters.",
  "{count} veza": "{count} links",
  "Uzorak:": "Sample:",
  "Metoda:": "Method:",
  "Operator:": "Operator:",
  "Mješavina:": "Blend:",
  "Komponente mješavine": "Blend components",
  "Dobavljač / sirovina": "Supplier / ingredient",
  "Rezultati": "Results",
  "Veza s probom": "Trial link",
  "opcionalno": "optional",
  "Poveži": "Link",
  "Sve dostupne probe su već povezane.": "All available trials are already linked.",
  "Greška pri učitavanju batcha: {message}": "Error loading batch: {message}",
  "Kod (MixCode)": "Code (MixCode)",
  "Lot proizvoda": "Product lot",
  "Verzija timelinea": "Timeline version",
  "Procesna linija": "Process line",
  "Finalna masa (kg)": "Final mass (kg)",
  "Vremena procesa": "Process times",
  "Nema zabilježenih procesnih parametara za ovaj batch.": "No process parameters recorded for this batch.",
  "Masa tijesta (kg)": "Dough mass (kg)",
  "pH ferm. 1 / 2": "pH ferm. 1 / 2",
  "Visina ferm. 1 / 2": "Height ferm. 1 / 2",
  "Visina zavr. 1 / 2": "Height final 1 / 2",
  "Pakirano (kom)": "Packed (pcs)",
  "Škart (kom)": "Scrap (pcs)",
  "Ručno": "Manual",
  "Nema evidencije utrošenih lotova sirovina za ovaj batch.": "No ingredient-lot consumption recorded for this batch.",
  "Dobavljač / izvor lota": "Supplier / lot source",
  "Dodjela": "Assignment",
  "Interna proizvodnja": "Internal production",
  "Ukupno": "Total",
  "Nema evidentiranih gotovih proizvoda za ovaj batch.": "No finished goods recorded for this batch.",
  "Količina (kom)": "Quantity (pcs)",
  "Nije dodijeljeno osoblje za ovaj batch.": "No staff assigned to this batch.",
  "Djelatnik": "Employee",
  "Uloga": "Role",
  "Nema zabilježenih promjena statusa.": "No status changes recorded.",
  "Iz statusa": "From status",
  "U status": "To status",
  "Batch nije pronađen.": "Batch not found.",
  "← Batchevi": "← Batches",
  "Greška pri učitavanju batcheva: {message}": "Error loading batches: {message}",
  "Batchevi (zamjesi)": "Batches (mixes)",
  "{count} rezultata": "{count} results",
  "Učitaj": "Load",
  "Pretraga (kod / proizvod / recept)": "Search (code / product / recipe)",
  "npr. MixCode, naziv proizvoda…": "e.g. MixCode, product name…",
  "Nema batcheva za odabrane filtere.": "No batches for the selected filters.",
  "Greška pri učitavanju metrika": "Error loading metrics",
  "Učitavanje metrika…": "Loading metrics…",
  "Za ovaj batch nema povezanih metrika. Poveži ih u prikazu dataseta (Assign batch).": "This batch has no linked metrics. Link them in the dataset view (Assign batch).",
  "Nema gotovih zamjesa": "No completed mixes",
  "Pećnica:": "Oven:",
  "Gotovo u:": "Done at:",
  "Nema planiranih obrada": "No scheduled processing",
  "Završetak:": "Finish:",
  "Proizvodni monitor": "Production monitor",
  "Nema planiranih zamjesa za danas": "No mixes scheduled for today",
  "Nema planiranog pečenja": "No baking scheduled",

  // Labels looked up via t(map[code]) / t(tab.label) / t(statusInfo.label)
  PLANIRANO: "PLANNED",
  SPREMNO: "READY",
  "U TIJEKU": "IN PROGRESS",
  GOTOVO: "DONE",
  "NA ČEKANJU": "ON HOLD",
  OTKAZANO: "CANCELLED",
  "U PEĆNICI": "IN OVEN",
  "SPREMNO ZA PAKIRANJE": "READY TO PACK",
  "U PAKIRANJU": "PACKING",
  "U OBRADI": "PROCESSING",
  Enzim: "Enzyme",
  "Mješavina sjemena": "Seed mix",
  "Sve linije moraju imati sirovinu, količinu > 0 i jedinicu":
    "Every line must have an ingredient, quantity > 0 and a unit",
  "Sve linije moraju imati sirovinu i PEK% > 0":
    "Every line must have an ingredient and baker's % > 0",
  "Od nule": "From scratch",
  "Iz recepta": "From recipe",
  "Iz pokusa": "From trial",
  "Sami složite recepturu, sastojak po sastojak.":
    "Build the recipe yourself, ingredient by ingredient.",
  "Preuzmite sastojke postojećeg recepta proizvoda.":
    "Start from the ingredients of an existing product recipe.",
  "Nastavite od ranije probe i mijenjajte postotke.":
    "Continue from a previous trial and change the percentages.",
  Metrike: "Metrics",
  "Sirovine (lotovi)": "Ingredients (lots)",
  "Povijest statusa": "Status history",
  "Svi testovi": "All tests",
  "QC odluke": "QC decisions",
  "Spec. vol. (L/kg)": "Spec. vol. (L/kg)",
  Ekstenzograf: "Extensograph",
  Amilograf: "Amylograph",
  Amilogram: "Amylogram",
};

export default en;
